<script>
import appConfig from '@src/app.config'
import { SweetModal } from 'sweet-modal-vue'

import {
  apiClient,
  uploadVideoService,
  notificationService,
  helperService,
} from '@services'
import Loader from '@components/loader/loader'
import VueLoader from '@components/loader/VueLoader'
import Multiselect from 'vue-multiselect'
import { VueEditor } from 'vue2-editor'
import VideoList from '@components/videoList/videoList'
import TopBarCamp from '@components/campaign-topbar'
import CampNav from '@components/campaign-nav'
import BaseButton from '@components/BaseButton'
import {
  CAMPAIGN_LIST,
  CAMPAIGN_TEST_EMAIL,
  GET_PROJECT_BY_ID,
  SOCIAL_GOOGLE_ACCOUNT,
  CAMPAIGN_ID_VALIDATE,
  CAMPAIGN_ID,
  GET_COMPAIGN,
  GET_MAIL_TEMPLATE,
} from '../../../constants/endponts'

export default {
  page: {
    title: 'Edit Campaign',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    CampNav,
    TopBarCamp,
    Loader,
    VideoList,
    VueEditor,
    Multiselect,
    VueLoader,
    SweetModal,
    BaseButton,
  },
  data() {
    return {
      VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
      projectId: this.$route.params.projectId,
      campaignId: this.$route.params.campaignId,
      page: 1,
      page_size: 100,
      secondaryLoading: false,
      campaignName: null,

      // Will need to rearrange this to allow multiple emails

      steps: [
        {
          name: 'generateList',
          selected: false,
        },
        {
          name: 'videosToSeach',
          selected: false,
          completed: false,
        },
        {
          name: 'subject',
          selected: false,
          completed: false,
        },
        {
          name: 'reviewAndEdit',
          selected: false,
          completed: false,
        },
      ],

      emailTemplate: {
        subject: '',
        testEmail: '',
        intro: '',
        body: '',
        name: '',
        previewImage: null,
        itemSelectedId: null,
        videoSelected: null,
        videoSkipped: null,
        start_after: 2,
        mailTemplate: null,
      },

      // TEST EMAIL INFORMATION
      // Create an array that you can add an object to for each email.
      // How do I add the first email here so it can be deleted later? Add an empty item to the array

      videoEmails: false,
      emailArray: [],
      activeEmailIndex: null,

      previewImage: null,
      itemSelectedId: null,
      videoSelected: null, // what is this?
      videoSkipped: null, // what is this? ((For each video chooser need to track which videos to grey out))

      // Only Need 1 per campaign
      customEditorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
      ],
      showGenerateListButton: false,
      generateListMessage: false,
      generatedList: false,
      emailSelected: [],

      mailTemplates: null,

      fileData: null,
      videos: [],
      videosNext: null, // url to next page with videos
      max: 200,

      // here we have saved Campaign object
      campaign: null,
      campaignList: null,
      filterDict: {},
      generateListOnSave: false,
      closeOnSave: false,

      currentActiveIndex: null,

      gmailMode: true,
      sparkPostMode: false,
      smtpMode: false,

      generateListDisabled: false,
      googleAccounts: null,
      smtpEmails: null,
      selectedSparkpostEmail: null,
      selectedGoogleAccounts: [], // user can select more than one account
      selectedSmtpEmail: null,

      loading: true,
      emailSending: false,

      campaignLists: null,
      // items that can be added to current campaign.campaign_list
      campaignListAdditional: null,

      initialCampaignLists: null,
      sparkpostEmails: null,
      showDifferentAccounts: {
        gmail: false,
        sparkpost: false,
      },
      lockStartCampaignButton: false, // This could be locked for many reasons - I would not lock it because you haven't previewed an email. Annoying as hell
      validateCampaignLock: false,
      validationMatchedWords: null,
      linksNav: [
        {
          id: 'campRec',
          name: 'Recipients',
        },
        {
          id: 'campFrom',
          name: 'From',
        },
        {
          id: 'campVideo',
          name: 'Video',
        },
        {
          id: 'campCompose',
          name: 'Compose',
        },
        // {
        //  id: 'campPre',
        //  name: 'Polish',
        // },
        {
          id: 'campOpt',
          name: 'Options',
        },
        {
          id: 'campSend',
          name: 'Send',
        },
      ],
      exampleEmails: [],
      campaignStatus: 0,
      options: [true, true, false, false],
      currentTab: 'campRec',
      showAllEmailMethods: false,
      editEmailSequence: false,
    }
  },
  computed: {
    breadcrumbs() {
      if (this.campaign && this.campaign.app.internal) {
        return [
          {
            name: 'Back to list of campaigns',
            path: '/email-campaigns',
          },
        ]
      } else {
        return [
          {
            name: 'Back to list of campaigns',
            path:
              '/projects/' + this.$route.params.projectId + '/email-campaigns',
          },
        ]
      }
    },
    campaignListWithoutSelected() {
      let items = []
      let currentCampaignList = []

      if (this.campaign && this.campaignLists && this.campaign.campaign_list) {
        for (var i in this.campaign.campaign_list) {
          currentCampaignList.push(this.campaign.campaign_list[i].id)
        }

        for (var e in this.campaignLists) {
          if (currentCampaignList.indexOf(this.campaignLists[e].id) === -1) {
            items.push(this.campaignLists[e])
          }
        }
      }
      return items
    },
    campaignListAdditionalLeadsCount() {
      let count = 0
      if (this.campaignListAdditional) {
        for (var i in this.campaignListAdditional) {
          count += this.campaignListAdditional[i].current_leads_count
        }
      }

      return count
    },
    allowEmptyCampaignList() {
      if (this.campaign.status !== 1) {
        return false
      }
      return true
    },
    stepOne() {
      return this.campaign.campaign_list.length > 0
    },
    stepTwo() {
      return (
        this.selectedGoogleAccounts.length ||
        this.selectedSparkpostEmail ||
        this.selectedSmtpEmail
      )
    },
    stepThree() {
      return !!this.videoSelected
    },
    currentCostWithVideo() {
      let basePrice = (this.campaign.total_leads_count * 0.01).toFixed(2)
      let count = this.emailArray.length || 1
      return basePrice * count
    },
    currentCost() {
      let currentAmount = 0
      if (this.campaign && this.emailArray) {
        for (var i in this.emailArray) {
          let email = this.emailArray[i]
          if (email.videoSelected) {
            // Don't give a discount for including a video - just an option
            currentAmount += this.campaign.total_leads_count * 0.01
          } else {
            currentAmount += this.campaign.total_leads_count * 0.01
          }
        }
      }
      return currentAmount.toFixed(2)
    },
    currentCostDifference() {
      return (this.currentCost - this.currentCostWithVideo).toFixed(2)
    },
    sendTestEmailsString() {
      if (this.selectedGoogleAccounts.length > 0) {
        let emails = []
        for (var i in this.selectedGoogleAccounts) {
          emails.push(this.selectedGoogleAccounts[i].account_email)
        }
        return emails.join(', ')
      }
      return ''
    },
    isCompleteCampaign() {
      if (this.emailArray) {
        for (var i in this.emailArray) {
          let email = this.emailArray[i]
          if (email.subject.length === 0) return false
          if (email.intro.length === 0 && email.body.length === 0) return false
        }
      }
      return true
    },
  },
  watch: {
    emailArray: {
      handler(val) {},
      deep: true,
    },
  },
  mounted() {
    Promise.all([
      this.getCampaignList(),
      this.getSparkpostEmails(),
      this.getGoogleAccounts(),
      this.getSmtpEmails(),
      this.getVideos(),
      this.getMailTemplates(),
    ])
      .then(() => {
        // Load after all campaign
        return this.getCampaign()
      })
      .then(
        () => {
          if (this.videoSelected) {
            this.selectVideo(this.campaign.content.id)
          }

          // select campaign list
          let campaingListId = this.$route.query.campaign_list_id
          if (campaingListId) {
            campaingListId = parseInt(campaingListId, 10)
            for (let index = 0; index < this.campaignLists.length; index++) {
              let item = this.campaignLists[index]
              if (item.id === campaingListId) {
                this.campaign.campaign_list.push(item)

                this.updateCampaign(false)
                break
              }
            }
          }

          // Select default self list if current list is empty
          // Select first campaign with list_type = 2
          try {
            const index = this.campaignLists.findIndex((i) => {
              return i.list_type === 2
            })
            if (index !== -1) {
              if (this.campaign.campaign_list.length === 0) {
                this.campaign.campaign_list.push(this.campaignLists[index])
                this.selectCampaignList(false)
              }
            }
          } catch (e) {}

          try {
            // select google account
            // this.campaign.google_accounts is list with ids
            if (
              this.campaign &&
              this.campaign.google_accounts.length &&
              this.googleAccounts
            ) {
              for (let index = 0; index < this.googleAccounts.length; index++) {
                let item = this.googleAccounts[index]

                if (this.campaign.google_accounts.indexOf(item.id) !== -1) {
                  this.selectedGoogleAccounts.push(item)
                }
              }
            }
            // select sparkpost account
            if (this.campaign && this.campaign.sparkpost_email) {
              for (
                let index = 0;
                index < this.sparkpostEmails.length;
                index++
              ) {
                let item = this.sparkpostEmails[index]
                if (item.id === this.campaign.sparkpost_email) {
                  this.selectedSparkpostEmail = item
                  break
                }
              }
            }

            // select smtp email
            if (this.campaign && this.campaign.smtp_email) {
              for (let index = 0; index < this.smtpEmails.length; index++) {
                let item = this.smtpEmails[index]
                if (item.id === this.campaign.smtp_email) {
                  this.selectedSmtpEmail = item
                  break
                }
              }
            }
          } catch (e) {}

          // check step param
          try {
            if (this.$route.query && this.$route.query.step === 'from') {
              this.currentTab = 'campFrom'
            }
          } catch (e) {}

          this.loading = false
        },
        () => {
          notificationService.error('Error occured, please refresh the page.')
        }
      )
  },
  methods: {
    convertSerializedObject(inputObject) {
      let obj = JSON.parse(JSON.stringify(this.emailTemplate))

      let objectCopy = JSON.parse(JSON.stringify(inputObject))
      obj.id = objectCopy.id
      obj.subject = objectCopy.subject
      obj.intro = objectCopy.intro
      obj.body = objectCopy.body
      obj.preview_url = objectCopy.preview_url

      if (objectCopy.name.length === 0) {
        obj.name =
          this.campaign.name + ', email drip ' + (this.emailArray.length + 1)
      } else {
        obj.name = objectCopy.name
      }

      if (objectCopy.content) {
        obj.itemSelectedId = objectCopy.content.id.toString()
        obj.videoSelected = objectCopy.content
      }

      if (objectCopy.start_after) {
        obj.start_after = objectCopy.start_after
      }

      // Select template
      if (objectCopy.mail_template) {
        for (let index = 0; index < this.mailTemplates.length; index++) {
          let item = this.mailTemplates[index]
          if (item.id === objectCopy.mail_template) {
            obj.mailTemplate = item
            break
          }
        }
      }

      // Select first mail template if not selected
      if (this.mailTemplates && !obj.mailTemplate) {
        obj.mailTemplate = this.mailTemplates[0]
      }

      return obj
    },
    getCampaign() {
      return apiClient
        .get(CAMPAIGN_ID(this.campaignId))
        .then(
          (res) => {
            this.campaign = res.data
            this.emailArray.push(this.convertSerializedObject(this.campaign))

            // add from subcampaigns
            for (var i in this.campaign.subcampaigns) {
              let subcampaignCopy = this.campaign.subcampaigns[i]
              this.emailArray.push(
                this.convertSerializedObject(subcampaignCopy)
              )
            }
          },
          (res) => {
            notificationService.handleResponse(res)
          }
        )
        .catch((err) => {
          return err
        })
    },
    getMailTemplates() {
      return apiClient
        .get(GET_MAIL_TEMPLATE)
        .then((res) => {
          this.mailTemplates = res.data.results
        })
        .catch((err) => {
          return err
        })
    },
    showGenerateList(e) {
      const element = e.target
      element.classList.add('active', 'text-white')
      this.showGenerateListButton = true
    },

    // Sequence Specific Functions
    addDrip(e) {
      // create campaign
      apiClient
        .post(GET_COMPAIGN, {
          app_id: this.projectId,
          parent_campaign: this.campaign.id,
        })
        .then(
          (res) => {
            // append created object to campaign
            this.emailArray.push(this.convertSerializedObject(res.data))
          },
          (res) => {
            notificationService.handleResponse(res)
          }
        )
    },
    deleteEmail(index) {
      if (this.currentActiveIndex) {
        let campaignId = this.emailArray[this.currentActiveIndex].id
        apiClient.delete(CAMPAIGN_ID(campaignId)).then(
          (res) => {
            this.emailArray.splice(this.currentActiveIndex, 1)
          },
          (res) => {
            notificationService.handleResponse(res)
          }
        )
      }
      this.closeDeleteModal()
    },
    chooseImage(event) {
      event.preventDefault()
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const reader = new FileReader()
      const input = this.$refs.fileInput
      const files = input.files
      reader.onload = (e) => {
        this.fileData = e.target.result
        this.previewImage = reader.result
      }
      reader.readAsDataURL(files[0])
      this.$emit('input', files[0])
    },
    onSelectFile(fileInput) {
      const input = this.$refs[fileInput]
      const files = input.files
      const callback = () => {
        this.getVideos()
        this.$forceUpdate()
      }

      if (files && files[0]) {
        const videoName = files[0].name
          .split('.')
          .slice(0, -1)
          .join('.')
        let formData = new FormData()
        formData.append('title', videoName)

        this.secondaryLoading = true

        uploadVideoService.upload(
          this.VUE_APP_API_BASE_URL,
          this.projectId,
          files[0],
          callback,
          formData
        )

        const reader = new FileReader()
        if (files[0].type.match('image')) {
          reader.onload = (e) => {
            this.previewImage = reader.result
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        } else {
          reader.onload = (e) => {
            let blob = new Blob([reader.result], { type: files[0].type })
            let url = URL.createObjectURL(blob)
            let video = document.createElement('video')

            let timeupdate = () => {
              if (image()) {
                video.removeEventListener('timeupdate', timeupdate)
                video.pause()
              }
            }

            video.addEventListener('loadeddata', () => {
              if (image()) {
                video.removeEventListener('timeupdate', timeupdate)
              }
            })

            let image = () => {
              let canvas = document.createElement('canvas')
              canvas.width = video.videoWidth
              canvas.height = video.videoHeight
              canvas
                .getContext('2d')
                .drawImage(video, 0, 0, canvas.width, canvas.height)
              let image = canvas.toDataURL()
              let success = image.length > 100000
              if (success) {
                let img = document.createElement('img')
                img.src = image
                this.previewImage = image
                URL.revokeObjectURL(url)
              }
              return success
            }
            video.addEventListener('timeupdate', timeupdate)
            video.preload = 'metadata'
            video.src = url
            video.muted = true
            video.playsInline = true
            video.play()
          }
          reader.readAsArrayBuffer(files[0])
        }
      }
    },
    getVideos() {
      return apiClient
        .get(
          GET_PROJECT_BY_ID(this.projectId) +
            'content/?page_size=' +
            this.page_size
        )
        .then((res) => {
          this.videos = res.data.results
          this.videosNext = res.data.next
          this.secondaryLoading = false
        })
        .catch((err) => {
          this.secondaryLoading = false
          return err
        })
    },
    getCampaignList() {
      // localhost:8080/projects/45843/campaign/41#campaign_list_id=50
      return apiClient
        .get(CAMPAIGN_LIST, { params: { page_size: 200 } })
        .then((res) => {
          this.campaignLists = res.data.results
          this.initialCampaignLists = JSON.parse(
            JSON.stringify(this.campaignLists)
          )
        })
        .catch((err) => {
          return err
        })
    },
    setActiveEmail(index) {
      this.activeEmailIndex = index
    },
    selectVideo(id, e) {
      // TODO: check active email index
      if (id) {
        id = id.toString()
      }

      const index = this.videos.findIndex((i) => {
        return i.id === Number(id)
      })

      if (id == null) {
        this.emailArray[this.activeEmailIndex].videoSelected = null
        this.emailArray[this.activeEmailIndex].itemSelectedId = id
      } else {
        if (
          this.emailArray[this.activeEmailIndex].videoSelected &&
          Number(id) === this.emailArray[this.activeEmailIndex].videoSelected.id
        ) {
          this.emailArray[this.activeEmailIndex].itemSelectedId = ''
          this.emailArray[this.activeEmailIndex].videoSelected = null
        } else {
          this.emailArray[this.activeEmailIndex].videoSelected = this.videos[
            index
          ]
          this.emailArray[this.activeEmailIndex].itemSelectedId = id
        }
      }
    },
    selectCampaignList(showNotifications = false) {
      // refresh list
      this.$nextTick(() => {
        // TODO: start only after timeout
        this.updateCampaign(showNotifications)
        this.generatedList = true
      })
    },
    nextStep() {
      this.steps[1].selected = false
      this.steps[2].selected = true
    },
    currentCampaignData() {
      let data = {
        app_id: this.projectId,
        name: this.campaign.name,
        subject: this.emailArray[0].subject,
        intro: this.emailArray[0].intro,
        body: this.emailArray[0].body,
        reply_to: this.campaign.reply_to,
        // TODO - how do I store this? campaignStatus: this.campaignStatus,
        campaign_list_id: this.campaign.campaign_list.map((i) => {
          return i.id
        }),
        content_id: this.emailArray[0].itemSelectedId,
      }

      if (this.emailArray[0].mailTemplate) {
        data.mail_template = this.emailArray[0].mailTemplate.id
      }

      // set first google account by default
      let googleAccounts = []
      if (this.selectedGoogleAccounts.length > 0) {
        for (var i in this.selectedGoogleAccounts) {
          googleAccounts.push(this.selectedGoogleAccounts[i].id)
        }
      }
      data.google_accounts = googleAccounts

      if (this.selectedSparkpostEmail) {
        data.sparkpost_email = this.selectedSparkpostEmail.id
      } else {
        data.sparkpost_email = null
      }

      if (this.selectedSmtpEmail) {
        data.smtp_email = this.selectedSmtpEmail.id
      } else {
        data.smtp_email = null
      }

      return data
    },
    updateCampaign(showNotifications) {
      if (showNotifications) notificationService.success('Saving campaign...')
      return apiClient
        .patch(CAMPAIGN_ID(this.campaign.id), this.currentCampaignData())
        .then(
          (res) => {
            this.campaign = res.data

            return res
          },
          (err) => {
            notificationService.handleResponse(err.response)
            return err
          }
        )
        .then((res) => {
          // save all sub-campaigns
          let promises = []

          for (var i in this.emailArray) {
            let emailItem = this.emailArray[i]
            if (emailItem.id === this.campaign.id) {
              continue
            }

            if (emailItem.id) {
              // update campaign
              let subcampaignData = {
                name: emailItem.name,
                subject: emailItem.subject,
                intro: emailItem.intro,
                body: emailItem.body,
                app_id: this.projectId,
                start_after: emailItem.start_after,
                mail_template: emailItem.mailTemplate.id,
                content_id: emailItem.itemSelectedId,
              }

              promises.push(
                apiClient.patch(CAMPAIGN_ID(emailItem.id), subcampaignData)
              )
            }
          }
          return Promise.all(promises)
        })
        .then((res) => {
          if (showNotifications) notificationService.success('Campaign saved!')
        })
    },
    validateCampaign() {
      this.validateCampaignLock = true
      this.updateCampaign(true).then(() => {
        apiClient.post(CAMPAIGN_ID_VALIDATE(this.campaign.id)).then(
          (res) => {
            notificationService.success('Mail validated')
            this.validationMatchedWords = res.data.matched_words
            this.validateCampaignLock = false
          },
          () => {
            this.validateCampaignLock = false
          }
        )
      })
    },
    startCampaign() {
      this.lockStartCampaignButton = true
      this.updateCampaign().then(() => {
        let url =
          this.VUE_APP_API_BASE_URL +
          '/api/v1/campaign/' +
          this.campaign.id +
          '/'

        apiClient
          .patch(url, {
            status: 1, // Set status as ongoing
          })
          .then(
            (res) => {
              notificationService.success('Campaign started')
              // redirect here
              this.$router.push(
                '/projects/' + this.projectId + '/email-campaigns'
              )
            },
            (err) => {
              notificationService.handleResponse(err.response)
              this.lockStartCampaignButton = false
            }
          )
      })
    },
    addAdditionalItems() {
      // move items
      for (var i in this.campaignListAdditional) {
        this.campaign.campaign_list.push(
          JSON.parse(JSON.stringify(this.campaignListAdditional[i]))
        )
      }

      this.updateCampaign().then(() => {
        this.campaignListAdditional = []
      })
    },
    previewCampaignEmail(index) {
      this.updateCampaign().then(() => {
        let previewUrl =
          this.VUE_APP_API_BASE_URL + this.emailArray[index].preview_url
        window.open(previewUrl, '_blank')
      })
    },
    openEpisodeLink() {
      let url =
        'https://dashboard.alphavoice.io/projects/' +
        this.projectId +
        '/episode/' +
        this.videoSelected.id +
        '/edit'
      // todo: Change this external link from numbers to slugs. ... let url = "https://www.alphavoice.io" + this.episodeInfo.external_url
      window.open(url, '_blank')
    },
    saveCampaignList(data) {
      let url =
        this.VUE_APP_API_BASE_URL +
        '/api/v1/campaign/' +
        this.campaign.id +
        '/list/'
      return apiClient
        .post(url, data)
        .then((res) => {
          this.campaignList = res.data
          return res
        })
        .catch((err) => {
          return err
        })
    },
    updateCampaignList(listId, data) {
      let url =
        this.VUE_APP_API_BASE_URL +
        '/api/v1/campaign/' +
        this.campaign.id +
        '/list/' +
        listId +
        '/'
      return apiClient
        .patch(url, data)
        .then((res) => {
          this.campaignList = res.data
          return res
        })
        .catch((err) => {
          return err
        })
    },
    close() {
      if (this.campaign && this.campaign.app.internal) {
        this.$router.push('/email-campaigns')
      } else {
        this.$router.push('/projects/' + this.projectId + '/email-campaigns')
      }
    },
    gotoVideos() {
      if (this.campaign && this.campaign.app.internal) {
        this.$router.push('/content-list')
      } else {
        this.$router.push('/projects/' + this.projectId + '/content-list')
      }
    },
    saveSequence() {
      if (this.campaign) {
        // update campaing
        // Campaign list saves only when user click to generate lead data
        // todo Need to check that all messages have been filled, subjects, bodies, etc...
        this.updateCampaign().then(() => {
          this.editEmailSequence = false
        })
      } else {
        this.modalAction('open')
      }
    },
    cancelSequence() {
      // todo: need to set fields back to what they were previously, while it doesn't save it may show the wrong info.
      this.editEmailSequence = false
    },
    saveAndClose() {
      this.closeOnSave = true
      if (this.campaign) {
        // update campaing
        // Campaign list saves only when user click to generate lead data
        this.updateCampaign().then(() => {
          this.close()
        })
      } else {
        this.modalAction('open')
      }
    },
    saveAndUploadVideos() {
      this.closeOnSave = true
      if (this.campaign) {
        // update campaing
        // Campaign list saves only when user click to generate lead data
        this.updateCampaign().then(() => {
          this.gotoVideos()
        })
      } else {
        this.modalAction('open')
      }
    },
    saveAndAttach() {
      if (this.campaignName && !this.campaign) {
        this.updateCampaign()
          .then((res) => {
            this.$router.push('/profile')
          })
          .catch((err) => {
            return err
          })
      } else {
        if (this.campaign) {
          // update campaing
          // Campaign list saves only when user click to generate lead data
          this.updateCampaign().then(() => {
            this.$router.push('/profile')
          })
        } else {
          this.modalAction('open')
        }
      }
    },
    saveAndAttachGoogle() {
      this.updateCampaign().then(() => {
        this.linkGoogleAccount()
      })
    },
    saveAndAttachSparkPost() {
      this.saveAndAttach()
    },
    saveAndAttachSmtp() {
      this.saveAndAttach()
    },
    getGoogleAccounts() {
      return apiClient
        .get(SOCIAL_GOOGLE_ACCOUNT)
        .then((res) => {
          this.googleAccounts = res.data.results
        })
        .catch((err) => {
          return err
        })
    },
    modalAction(action) {
      if (action === 'open') {
        this.$refs.modal.open()
      } else {
        this.$refs.modal.close()
      }
    },
    linkGoogleAccount() {
      let returnUrl = ''
      if (this.VUE_APP_API_BASE_URL === 'http://localhost:8000') {
        returnUrl = 'http://localhost:8080'
      } else {
        returnUrl = 'https://dashboard.alphavoice.io'
      }

      let url =
        this.VUE_APP_API_BASE_URL +
        '/accounts/google/login/?process=connect&next=' +
        encodeURI(returnUrl + this.$route.path)

      helperService
        .getSession({
          url: url,
        })
        .then((response) => {
          let key = response.data.key
          let redirectUrl =
            this.VUE_APP_API_BASE_URL +
            helperService.getSessionUrl() +
            '?key=' +
            key
          window.open(redirectUrl, '_self')
        })
    },
    getSparkpostEmails() {
      return helperService.getSparkPostEmails().then((res) => {
        this.sparkpostEmails = res.data.results
        return res
      })
    },
    openProspects() {
      // /projects/:projectId/prospects
      this.$router.push(
        '/projects/' +
          this.projectId +
          '/prospects?campaign_list=' +
          this.campaignId
      )
    },
    importList() {
      // /projects/:projectId/prospects
      this.$router.push(
        '/contacts/import?campaign_list=' +
          this.campaignId +
          '&app_id=' +
          this.projectId
      )
    },
    sendTestEmail(index) {
      this.emailSending = true

      this.updateCampaign().then(() => {
        let campaignId = this.emailArray[index].id
        apiClient
          .post(CAMPAIGN_TEST_EMAIL, {
            campaign_id: campaignId,
            email: this.emailArray[index].testEmail,
          })
          .then((res) => {
            this.emailSending = false
            notificationService.success(
              'Mail sent successfully. Please check your mailbox'
            )
          })
          .catch((err) => {
            notificationService.handleResponse(err.response)
            this.emailSending = false
            return err
          })
      })
    },
    getSmtpEmails() {
      return helperService.getSmtpEmails().then((res) => {
        this.smtpEmails = res.data.results
        return res
      })
    },
    save() {
      this.updateCampaign().then(() => {})
    },
    selectEmail(emailClient, email) {
      if (emailClient === 'google') {
        if (
          this.selectedGoogleAccounts.filter(
            (i) => i.account_email === email.account_email
          ).length
        ) {
          for (var i in this.selectedGoogleAccounts) {
            if (this.selectedGoogleAccounts.hasOwnProperty(i)) {
              if (
                this.selectedGoogleAccounts[i].account_email ===
                email.account_email
              ) {
                delete this.selectedGoogleAccounts[i]
                this.selectedGoogleAccounts.splice(i, 1)
                if (this.selectedGoogleAccounts.length < 2) {
                  this.campaign.reply_to = ''
                }
              }
            }
          }
        } else {
          var arr = this.googleAccounts.filter(
            (i) => i.account_email === email.account_email
          )
          this.selectedGoogleAccounts = this.selectedGoogleAccounts.concat(arr)
        }
      }
      if (emailClient === 'smtp') {
        this.selectedSmtpEmail = email
      }
      if (emailClient === 'sparkpost') {
        this.selectedSparkpostEmail = email
      }
    },
    gmailStep() {
      this.sendWithGmail.step = this.sendWithGmail.step + 1
    },
    defaultEmail(emailClient) {
      this.selectedGoogleAccounts = []
      this.selectedSparkpostEmail = null
      this.selectedSmtpEmail = null

      if (emailClient === 'google') {
        this.gmailMode = !this.gmailMode
        this.sparkPostMode = false
        this.smtpMode = false
        if (this.googleAccounts[0]) {
          this.selectedGoogleAccounts.push(this.googleAccounts[0])
        }
      } else if (emailClient === 'sparkpost') {
        this.gmailMode = false
        this.sparkPostMode = !this.sparkPostMode
        this.smtpMode = false
        if (this.sparkpostEmails[0]) {
          this.selectedSparkpostEmail = this.sparkpostEmails[0]
        }
      } else if (emailClient === 'smtp') {
        this.gmailMode = false
        this.sparkPostMode = false
        this.smtpMode = !this.smtpMode
        if (this.smtpEmails[0]) {
          this.selectedSmtpEmail = this.smtpEmails[0]
        }
      }
    },
    googleAccountIsSelected(item) {
      return (
        this.selectedGoogleAccounts.filter((i) => i.id === item.id).length > 0
      )
    },
    hideVideoSelectingBlock(index) {
      let el = document.querySelector('#videoToSearch-' + index)
      if (el) {
        el.classList.remove('show')
      }

      return true
    },
    hideEditBlock(index) {
      let el = document.querySelector('#reviewAndEdit-' + index)
      el.classList.remove('show')
      return true
    },
    openDeleteEmailModal(index) {
      this.$refs.deleteModal.open()
      this.currentActiveIndex = index
    },
    closeDeleteModal() {
      this.$refs.deleteModal.close()
    },
    openStartCampaignModal(index) {
      this.$refs.startCampaignModal.open()
    },
    closeStartCampaignModal() {
      this.$refs.startCampaignModal.close()
    },
    changeVideoEmail() {
      if (this.videoEmails) {
        this.videoEmails = false
        for (var i in this.emailArray) {
          this.emailArray[i].videoSelected = null
        }
      } else {
        this.videoEmails = true
      }
    },
    editSequence() {
      this.editEmailSequence = true
    },
    videoEmailStatusChange(e) {
      // TODO: Create an endpoint and a campaign variable for activated video email campaigns
      const url =
        GET_PROJECT_BY_ID(this.project.id) +
        'content_turnstile/' +
        this.turnstileInfoOriginal.id +
        '/'
      apiClient
        .patch(url, this.turnstileInfo)
        .then((res) => {
          this.$emit('loader', false)
          // location.reload()
          notificationService.success('Saved!')
          return res
        })
        .catch((err) => {
          // this.$emit('loader', false)
          this.$emit('modal-error', 'modalError')
          return err
        })
    },
    combineExampleEmails() {
      if (this.campaign.campaign_list[0].contacts_preview_items.length) {
        let keys = this.campaign.campaign_list[0].contacts_preview_items[0]
        let index = 0
        for (const [i, value] of keys) {
          if (value === 'email') {
            index = i
          }
        }

        let emails = []

        for (const [y, item] of this.campaign.campaign_list[0]
          .contacts_preview_items) {
          let email = item[index]
          if (y > 0) {
            this.exampleEmails.push(email)
          }
        }
        return emails.join(', ')
      }
      return ''
    },
    createExampleEmails() {
      // TODO: Delete this function
      let keys = this.campaign.campaign_list[0].contacts_preview_items[0]
      let index = 0
      for (const [i, value] of keys) {
        if (value === 'email') {
          index = i
        }
      }
      for (const [y, item] of this.campaign.campaign_list[0]
        .contacts_preview_items) {
        let email = item[index]
        if (y > 0) {
          this.exampleEmails.append(email)
        }
      }
    },
    truncate_name(text, length, clamp) {
      clamp = clamp || '...'
      var node = document.createElement('div')
      node.innerHTML = text
      var content = node.textContent
      return content.length > length
        ? content.slice(0, length) + clamp
        : content
    },
    next_step(page, step) {
      this.currentTab = step
      if (page + 1 > this.campaignStatus) {
        this.campaignStatus = page + 1
      }
    },
    showAllEmailTypes() {
      this.showAllEmailMethods = true
    },
    showOneEmailType() {
      this.showAllEmailMethods = false
    },
    openVideoNewTab() {
      window.open(
        'https://www.alphavoice.io/creator/alpha-voice/alphavoice-at-web-summit',
        '_blank'
      )
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div class="create-campaign">
    <div v-if="loading">
      <div class="spinner-container">
        <VueLoader />
      </div>
    </div>
    <!--
    <div class="topbar bg-dark">
      <div class="d-flex align-items-center justify-content-between container">
        <Breadcrumb
          :show-back-arrows="true"
          :list="breadcrumbs"
          class="text-gray-input gray-breadcrumbs"
        />
        <div>
          <button
            class="btn btn-outline-secondary border-0"
            @click="saveAndClose"
            >Save & Finish later</button
          >
          <button class="btn btn-outline-gray border-0">Draft</button>
        </div>
      </div>
    </div>
    -->

    <span v-if="campaign && campaign.status !== 0">
      <TopBarCamp page="live" />
      <CampNav page="Sequence" />
      <!-- This is what a live campaign looks like -->

      <!-- Just show the sequence here, you can edit the emails || have a pause and edit button -->
      <div class="col-sm-12">
        <div id="campCompose" class="project-settings pt-0">
          <span>
            <div class="text-center py-3">
              <button
                v-if="!editEmailSequence"
                class="btn btn-secondary font-weight-normal px-4"
                @click.prevent="editSequence"
                >Edit Sequence
              </button>
              <button
                v-if="editEmailSequence"
                class="btn btn-secondary font-weight-normal px-4"
                @click.prevent="saveSequence"
                >Save Changes
              </button>
              <button
                v-if="editEmailSequence"
                class="btn btn-grey font-weight-normal px-4"
                @click.prevent="cancelSequence"
                >Cancel
              </button>
            </div>
          </span>

          <!-- Header -->
          <div class="row">
            <div class="col">
              <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                Edit your email campaign
              </h2>
            </div>
            <div class="col"> </div>
          </div>
          <!-- Compose Email Steps -->
          <span>
            <!-- One Step for Each Email in the Sequence -->
            <div v-for="(form, index) in emailArray" :key="index">
              <!-- Add another email in the sequence -->

              <!-- Choose video and write content per video -->
              <div class="row">
                <div class="col">
                  <!-- <b>Email {{ index + 1 }}. </b> -->
                  <!--<medium class="text-purple"><b>{{form.subject}}</b></medium>-->

                  <!-- I'm commenting this out to prevent confusion: This name is not the subject of the email
                  <div v-if="index !== 0" class="form-group"
                    ><br />
                    <BaseInputText
                      v-model="emailArray[index].name"
                      :placeholder="`Email drip name here`"
                  /></div>
                  -->
                </div>
                <div class="col"> </div>
              </div>

              <span v-if="index > 0">
                <div class="row py-4">
                  <div class="col">
                    <!--<medium><b>Drip</b></medium>-->
                    <div class="form-group">
                      <label for="projectName">
                        <small>Wait X Days</small>
                      </label>
                      <div class="col-sm-2 px-0">
                        <BaseInputText
                          v-model="emailArray[index].start_after"
                          name="emailDripDays"
                          type="number"
                          :placeholder="`2`"
                          :disabled="!editEmailSequence"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col"> </div>
                </div>
              </span>

              <div
                id="stepsGroup"
                class="card mb-4 overflow-initial steps-group"
              >
                <!-- STEP THREE  -->

                <div
                  v-if="!campaign.app.internal && videoEmails"
                  class="step-box"
                >
                  <div class="py-3 px-3 ">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex align-items-center">
                        <span class="mr-2">
                          <img
                            v-if="emailArray[index].itemSelectedId"
                            src="@assets/images/icons/grey-check.svg"
                            alt=""
                          />
                          <img
                            v-else
                            src="@assets/images/icons/white-check.svg"
                            alt=""
                          />
                        </span>
                        <p class="mt-1 mb-0 font-weight-bold">
                          Which video are you sharing?
                        </p>
                        <p
                          class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                          ><b v-if="emailArray[index].videoSelected">
                            {{
                              truncate_name(
                                emailArray[index].videoSelected.title,
                                60,
                                '...'
                              )
                            }}
                          </b></p
                        >
                      </div>

                      <button
                        class="btn font-weight-normal px-4 btn-collapse"
                        :class="stepThree ? 'btn-primary' : 'btn-outline-gray'"
                        data-toggle="collapse"
                        :href="'#videoToSearch-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="videoToSearch"
                        @click="setActiveEmail(index)"
                        >Select your video</button
                      >
                    </div>
                  </div>
                  <div
                    :id="'videoToSearch-' + index"
                    class="collapse"
                    data-parent="#stepsGroup"
                  >
                    <div class="py-3 px-3 ">
                      <div
                        class="d-flex align-items-center justify-content-between mt-3 mb-0"
                      >
                        <small class="text-left font-weight-light"
                          >Select your video</small
                        >
                      </div>

                      <div class="card card-body position-relative pt-0">
                        <div
                          v-if="secondaryLoading"
                          class="add-episode__loader add-episode__loader--save position-absolute w-100 h-100"
                        >
                          <Transition appear>
                            <div class="spinner-container">
                              <Loader />
                            </div>
                          </Transition>
                        </div>

                        <div
                          v-if="videos.length <= 0"
                          class="container upload mb-4 pt-4 pb-2"
                        >
                          <p
                            >Send Without a Video or Upload a Video to your
                            channel</p
                          >
                          <p
                            ><a
                              >Link to the Channel Page where you can add an
                              episode -- maybe straight to the add an episode
                              page. Save and go there.</a
                            ></p
                          >
                          <p>Also Need An Option to just Send with no Video</p>
                        </div>

                        <div v-else>
                          <div
                            class="videos-container modal-videos__container my-4"
                          >
                            <VideoList
                              v-if="videos"
                              :videos="videos"
                              :zoom="false"
                              :select-video="selectVideo"
                              :upload-videos="true"
                              :select-manually="true"
                              :id-selected="emailArray[index].itemSelectedId"
                              :campaign-selection="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="emailArray[index].itemSelectedId"
                      class="bg-dark p-3 d-flex alignt-items-center justify-content-end"
                    >
                      <button
                        class="btn btn-primary  mx-3"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="
                          selectVideo(null)
                          hideVideoSelectingBlock(index)
                        "
                      >
                        Unselect video & Continue
                      </button>

                      <button
                        class="btn btn-primary"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="hideVideoSelectingBlock(index)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>

                <!-- STEP FOUR -->
                <div class="py-3 px-3 step-box">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <span class="mr-2">
                        <img
                          v-if="
                            emailArray[index].subject &&
                              emailArray[index].intro &&
                              emailArray[index].body
                          "
                          src="@assets/images/icons/grey-check.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="@assets/images/icons/white-check.svg"
                          alt=""
                        />
                      </span>
                      <span v-if="emailArray[index].subject">
                        <p class="mt-1 mb-0 font-weight-bold text-align-right"
                          ><b
                            >Email {{ index + 1 }} :
                            <span class="text-purple">{{
                              truncate_name(
                                emailArray[index].subject,
                                60,
                                '...'
                              )
                            }}</span></b
                          ></p
                        >
                      </span>
                      <span v-else>
                        <p class="mt-1 mb-0 font-weight-bold"
                          >What are you teaching?
                        </p>
                      </span>
                    </div>

                    <div>
                      <button
                        v-if="campaign && emailArray[index].id !== campaign.id"
                        class="btn btn-outline-danger font-weight-light"
                        :disabled="
                          emailArray[index].id === campaign.id ||
                            !editEmailSequence
                        "
                        @click="openDeleteEmailModal(index)"
                      >
                        <span class="float-right">
                          <BaseIcon name="trash" />
                        </span>
                      </button>

                      <button
                        class="btn btn-primary font-weight-normal btn-collapse"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        :disabled="!editEmailSequence"
                        @click="videoSkipped = true"
                        >Compose your email</button
                      >
                    </div>
                  </div>
                  <div
                    :id="'reviewAndEdit-' + index"
                    class="collapse"
                    data-parent="#stepsGroup"
                  >
                    <div class="card card-body">
                      <div class="bg-light px-5 py-4">
                        <div class="row">
                          <div class="col-sm-12 col-md-10 mx-auto">
                            <div class="card px-3 py-4">
                              <div
                                v-if="
                                  campaign.campaign_list_variables &&
                                    Object.keys(
                                      campaign.campaign_list_variables
                                    ).length > 0
                                "
                                class="d-flex align-items-center subject-variables"
                              >
                                <p class="font-weight-bold mr-2"
                                  >Variables
                                  <small>
                                    - these are mapped from your recipient
                                    data</small
                                  ></p
                                >
                              </div>
                              <div
                                v-if="
                                  campaign.campaign_list_variables &&
                                    Object.keys(
                                      campaign.campaign_list_variables
                                    ).length > 0
                                "
                                class="d-flex align-items-center subject-variables mb-4"
                              >
                                <span
                                  v-for="(v,
                                  clvI) in campaign.campaign_list_variables"
                                  :key="clvI"
                                  class="badge badge-secondary bg-white border border-secondary text-secondary p-1 mr-2"
                                >
                                  <span v-pre>{</span>{{ v
                                  }}<span v-pre>}</span>
                                </span>
                              </div>

                              <div
                                class="d-flex align-items-center subject-variables mb-0"
                              >
                                <p class="font-weight-bold mr-2"
                                  >Subject Line</p
                                >
                              </div>

                              <div class="form-group">
                                <BaseInputText
                                  v-model="emailArray[index].subject"
                                  name="subject"
                                  type="text"
                                  :placeholder="''"
                                  class="mb-1"
                                  :maxlength="max"
                                />
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <!-- <router-link tag="a" to="#">
                                    <small class="text-purple font-weight-light">
                                      How do I write a good subject line?
                                    </small>
                                  </router-link> -->

                                  <small
                                    class="input-group-addon text-gray-input"
                                    v-text="
                                      max -
                                        emailArray[index].subject.length +
                                        ' characters left'
                                    "
                                  ></small>
                                </div>
                                <!-- <button class="btn btn-outline-gray-input px-4 d-block mx-auto my-4">Save</button> -->
                              </div>

                              <span v-if="emailArray[index].videoSelected">
                                <p class="font-weight-bold mr-2 mb-1"
                                  >Intro (optional)</p
                                >
                                <VueEditor
                                  v-model="emailArray[index].intro"
                                  :editor-toolbar="customEditorToolbar"
                                ></VueEditor>
                              </span>

                              <div
                                v-if="emailArray[index].videoSelected"
                                id="mainVideo"
                                class="embed-responsive embed-responsive-16by9 my-4 position-relative"
                              >
                                <div
                                  class="font-weight-light text-gray h6 m-0 video-description pr-5"
                                >
                                  <iframe
                                    :src="
                                      emailArray[index].videoSelected.player_url
                                    "
                                    frameborder="0"
                                    scrolling="no"
                                    allow="autoplay; fullscreen; encrypted-media"
                                    allowfullscreen
                                  ></iframe>
                                </div>
                                <button
                                  class="btn bg-transparent border-0 px-0 position-absolute btn-edit"
                                  @click.prevent="openEpisodeLink"
                                >
                                  <span class="text-primary"
                                    ><BaseIcon name="edit"
                                  /></span>
                                </button>
                              </div>

                              <!--
                              <div v-else>
                                <div class="clearfix"><br /></div>
                                <div class="clearfix"><br /></div>
                                <div class="clearfix"><br /></div>
                              </div>
                              -->

                              <p class="font-weight-bold mr-2 mb-1">
                                Body
                              </p>
                              <VueEditor
                                v-model="emailArray[index].body"
                                :editor-toolbar="customEditorToolbar"
                              ></VueEditor>
                            </div>

                            <!-- <button
                              class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                              :disabled="
                                (!emailArray[index].intro && !emailArray[index].body) || validateCampaignLock
                              "
                              @click.prevent="validateCampaign"
                            >
                              Save & Check Spam Score
                            </button> -->

                            <div
                              v-if="
                                validationMatchedWords &&
                                  validationMatchedWords.length > 0
                              "
                            >
                              Try to replace or remove the following words and
                              check again<br />
                              <span
                                v-for="(word, idx) in validationMatchedWords"
                                :key="idx"
                                class="badge badge-purple font-weight-normal mr-1 mb-1 py-1"
                                >{{ word }}</span
                              >
                              <p class="help-block"
                                ><small
                                  >Spam filters may reject mail sent with these
                                  words.</small
                                ></p
                              >
                            </div>

                            <div
                              v-if="
                                validationMatchedWords &&
                                  validationMatchedWords.length === 0
                              "
                            >
                              Cool! No spammy words found!<br />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="bg-white px-5 pt-4 pb-2">
                        <div class="row">
                          <div class="col-sm-12 col-md-6 mx-auto">
                            <div v-if="mailTemplates">
                              <h3>Choose an email template</h3>
                              <Multiselect
                                v-model="emailArray[index].mailTemplate"
                                select-label="Select"
                                :allow-empty="false"
                                class="multiselect-episode-actions mx-auto"
                                :options="mailTemplates"
                                track-by="id"
                                label="title"
                                :multiple="false"
                                :close-on-select="true"
                                placeholder="Mail template"
                              />
                              <br />
                              <span v-if="googleAccounts.length > 0">
                                <h3>Send a test email</h3>
                              </span>
                            </div>

                            <div
                              v-if="googleAccounts.length > 0"
                              class="input-group "
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-secondary py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email</button
                                >
                              </div>
                            </div>
                            <p
                              v-if="selectedGoogleAccounts.length > 0"
                              class="font-weight-bold"
                              ><br />Gmail sending accounts -
                              {{ sendTestEmailsString }}</p
                            >

                            <!--<h3 v-if="selectedSparkpostEmail">Send test email to: </h3>-->
                            <div
                              v-if="selectedSparkpostEmail"
                              class="input-group mb-3"
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-gray py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email from
                                  {{ selectedSparkpostEmail.email }}</button
                                >
                              </div>
                            </div>

                            <h3 v-if="selectedSmtpEmail"
                              >Send test email to:
                            </h3>
                            <div
                              v-if="selectedSmtpEmail"
                              class="input-group mb-3"
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-gray py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email from
                                  {{ selectedSmtpEmail.email }}</button
                                >
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="
                              selectedGoogleAccounts.length > 0 ||
                                selectedSparkpostEmail ||
                                selectedSmtpEmail
                            "
                          >
                            <div class="col-sm-12 col-md-12 mx-auto">
                              <button
                                v-if="campaign"
                                class="btn btn-primary font-weight-light px-5"
                                @click="previewCampaignEmail(index)"
                              >
                                Preview email
                                <span class="pl-3 float-right">
                                  <BaseIcon name="external-link-alt" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--
                      <div class="bg-white px-5 pt-4 pb-2">
                        <div class="row">
                          <div class="col-sm-12 col-md-8 mx-auto"> </div>

                          <div>
                            <div class="col-sm-12 col-md-12 mx-auto">
                              <button
                                v-if="campaign"
                                class="btn btn-purple font-weight-light px-5"
                                :disabled="emailArray[index].id === campaign.id"
                                @click="openDeleteEmailModal(index)"
                              >
                                DELETE email
                                <span class="pl-3 float-right">
                                  <BaseIcon name="trash" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      -->
                    </div>

                    <!--
                    <div
                      v-if="
                        selectedGoogleAccounts.length > 0 ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      class="bg-white pt-2 pb-4 text-center"
                    >
                      <div class="row">
                        <div class="col-sm-12 col-md-10 mx-auto">
                          <button
                            v-if="campaign"
                            class="btn btn-primary font-weight-light px-5"
                            @click="previewCampaign"
                          >
                            Preview email
                            <span class="pl-3 float-right">
                              <BaseIcon name="external-link-alt" />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                    -->

                    <div
                      v-if="emailArray[index].subject && emailArray[index].body"
                      class="bg-dark p-3 d-flex alignt-items-center justify-content-end"
                    >
                      <button
                        class="btn btn-primary"
                        data-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="hideEditBlock(index)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add another email button -->
              <span v-if="index === emailArray.length - 1">
                <div class="text-center">
                  <button
                    class="btn btn-outline-gray font-weight-light my-3 px-4 mx-2"
                    :disabled="!editEmailSequence"
                    @click.prevent="addDrip"
                  >
                    + Add Drip
                  </button>
                </div>
              </span>
            </div>
          </span>
        </div>
      </div>
    </span>
    <!-- <CampNav v-else page='Create' /> -->
    <span v-else-if="campaign">
      <TopBarCamp page="draft" />
      <CampNav page="Create" />

      <!-- *** NAV STEPS *** -->
      <div class="col-sm-12">
        <ul
          class="nav nav-tabs mb-0 d-none d-lg-flex align-items-center justify-content-center py-2 border-0"
        >
          <li v-for="(link, index) in linksNav" :key="link.id" class="nav-item">
            <button
              :id="`${linksNav.id}-tab`"
              :class="[
                link.id === currentTab
                  ? 'bg-transparent nav-link font-weight-light active'
                  : 'bg-transparent nav-link font-weight-light',
                campaignStatus >= index ? 'text-purple' : 'text-gray-input',
              ]"
              :disabled="campaignStatus < index"
              @click="() => (currentTab = link.id)"
            >
              <small>{{ link.name }}</small>
            </button>
          </li>
        </ul>
      </div>

      <!-- *** STEPS *** -->
      <div class="col-sm-12">
        <!-- Step ONE Recipients -->
        <div
          v-if="currentTab === 'campRec'"
          id="campRec"
          class="project-settings active pt-0"
        >
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                  Recipients
                </h2>
                <!-- Next Button -->
                <span>
                  <div class="text-center">
                    <BaseButton
                      :click="() => next_step(0, 'campFrom')"
                      :disabled="campaign.total_leads_count <= 0"
                      tooltip-message="You need to select a list to continue"
                    >
                      Next >
                    </BaseButton>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <!-- Step ONE Recipients -->
          <div id="stepsGroup1" class="card mb-4 overflow-initial steps-group">
            <div class="py-3 px-3 step-box">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="stepOne"
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold"
                    >Who are you sending to?</p
                  >
                  <p
                    class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                    ><b>{{ campaign.total_leads_count }} Recipients</b></p
                  >
                </div>
                <button
                  class="btn btn-primary font-weight-normal px-4 btn-collapse"
                  data-toggle="collapse"
                  href="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  >Create your list</button
                >
              </div>
              <div
                id="collapseExample"
                class="collapse show"
                data-parent="#stepsGroup"
              >
                <div class="card card-body step-one ">
                  <p class="text-center font-weight-light">Do you want to</p>
                  <div
                    class="d-flex align-items-top justify-content-center pb-4 mb-2 list-options"
                  >
                    <button
                      id="generateList"
                      class="btn btn-outline-secondary btn-generate-list"
                      :disabled="campaign.status === 3"
                      @click.prevent="openProspects"
                    >
                      <span class="text-secondary-light">
                        <BaseIcon name="plus" />
                      </span>
                      Generate a List
                    </button>
                    <p class="text-center font-weight-light my-0 mx-3 mt-2"
                      >or</p
                    >
                    <button
                      id="generateList"
                      class="btn btn-outline-secondary btn-generate-list"
                      :disabled="campaign.status === 3"
                      @click.prevent="importList"
                    >
                      <span class="text-secondary-light">
                        <BaseIcon name="plus" />
                      </span>
                      Import a List
                    </button>
                    <p class="text-center font-weight-light my-0 mx-3 mt-2"
                      >or</p
                    >
                    <div
                      v-if="campaign && campaignLists"
                      class="input-group px-0 my-0 lists-created"
                    >
                      <Multiselect
                        v-model="campaign.campaign_list"
                        deselect-label="Remove"
                        class="location-select"
                        open-direction="bottom"
                        :options="campaignLists"
                        :multiple="true"
                        track-by="id"
                        label="name"
                        :close-on-select="true"
                        :allow-empty="allowEmptyCampaignList"
                        :disabled="campaign.status !== 0"
                        placeholder="Select a lists..."
                        @select="selectCampaignList"
                        @remove="selectCampaignList"
                      />
                    </div>
                  </div>
                  <div
                    v-if="campaign.total_leads_count > 0"
                    class="text-center pb-4 mb-2"
                  >
                    <h3 class="mb-0">
                      We found
                      <span>{{ campaign.total_leads_count }}</span> emails
                    </h3>
                  </div>

                  <div
                    v-if="
                      campaign.status !== 0 &&
                        campaignListWithoutSelected &&
                        campaign.allowed_resume
                    "
                    class="text-center pb-4 mb-2"
                  >
                    <div class="row">
                      <div class="col">
                        You can add additional lists to the current campaign:
                      </div>
                      <div class="col">
                        <Multiselect
                          v-model="campaignListAdditional"
                          deselect-label="Remove"
                          class="location-select"
                          open-direction="bottom"
                          :options="campaignListWithoutSelected"
                          :multiple="true"
                          track-by="id"
                          label="name"
                          :close-on-select="true"
                          placeholder="Select a lists..."
                        />
                      </div>
                      <div class="col"
                        ><button
                          class="btn btn-primary"
                          :disabled="!campaignListAdditional"
                          @click="addAdditionalItems"
                          >Add items to current campaign
                          <span v-if="campaignListAdditionalLeadsCount"
                            >(selected
                            {{ campaignListAdditionalLeadsCount }})</span
                          ></button
                        ></div
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Next Button --
          <span>
            <div class="text-center">
              <BaseButton
                :click="() => next_step(0, 'campFrom')"
                :disabled="campaign.total_leads_count <= 0"
                tooltipMessage="You need to select a list to continue"
              >
                Next >
              </BaseButton>
            </div>
          </span> -->
        </div>

        <!-- Step TWO From Email -->
        <div
          v-if="currentTab === 'campFrom'"
          id="campFrom"
          class="project-settings pt-0"
        >
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                  Sending Address
                </h2>
                <!-- Next Button -->
                <span>
                  <div class="text-center px-4">
                    <BaseButton
                      :click="() => next_step(1, 'campVideo')"
                      :disabled="
                        !(
                          (selectedGoogleAccounts.length ||
                            selectedSparkpostEmail ||
                            selectedSmtpEmail) &&
                          (gmailMode || sparkPostMode || smtpMode)
                        )
                      "
                      tooltip-message="You must select an email address"
                    >
                      Next >
                    </BaseButton>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <!-- Step TWO From Email -->
          <div id="stepsGroup1" class="card mb-4 overflow-initial steps-group">
            <div class="py-3 px-3 step-box">
              <!-- Screwed up dropdown -->
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="
                        stepTwo ||
                          selectedGoogleAccounts.length ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold">
                    Who are you sending from?
                  </p>

                  <span v-if="selectedSparkpostEmail">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>{{ selectedSparkpostEmail.email }}</b></p
                    >
                  </span>
                  <span v-if="selectedSmtpEmail">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>{{ selectedSmtpEmail.email }}</b></p
                    >
                  </span>
                  <span v-if="selectedGoogleAccounts">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>{{ sendTestEmailsString }}</b></p
                    >
                  </span>
                </div>
                <button
                  class="btn btn-primary font-weight-normal px-4"
                  data-toggle="collapse"
                  href="#emailAddress"
                  role="button"
                  aria-expanded="false"
                  aria-controls="emailAddress"
                  >Choose an email address</button
                >
                <!--
                  :class="
                    stepTwo ||
                    selectedGoogleAccounts.length ||
                    selectedSparkpostEmail ||
                    selectedSmtpEmail
                      ? 'btn-primary'
                      : 'btn-outline-gray'
                  "
                  :disabled="
                    !stepOne &&
                    selectedGoogleAccounts.length === 0 &&
                    !selectedSparkpostEmail
                      ? true
                      : false
                  "
                  -->
              </div>
              <!-- End Screwed Up Dropdown -->

              <div
                id="emailAddress"
                class="collapse show"
                data-parent="#stepsGroup"
              >
                <div
                  id="emailOptions"
                  class="card card-body step-one email-options"
                >
                  <p class="text-center font-weight-light"
                    >You can send to {{ campaign.total_leads_count }} recipients
                  </p>
                  <div
                    class="d-flex align-items-top justify-content-center pb-4 mb-2"
                  >
                    <div>
                      <button
                        id="sendWithGmail"
                        class="btn btn-collapse px-4"
                        :class="!gmailMode && 'show collapsed'"
                        data-toggle="collapse"
                        href="#emailAddressGmail"
                        role="button"
                        :aria-expanded="selectedGoogleAccounts.length > 0"
                        aria-controls="emailAddressGmail"
                        @click="defaultEmail('google')"
                      >
                        Send with Gmail
                      </button>
                      <div class="mb-0 mt-1 text-center">
                        <small class="font-italic font-wwight-light"
                          >400 emails/day max
                          <button
                            v-if="!showAllEmailMethods"
                            class="btn btn-outline-secondary border-0 d-block mx-auto px-2 mt-2 font-weight-light btn-save-attach"
                            @click.prevent="showAllEmailTypes"
                          >
                            more
                          </button>
                        </small>
                      </div>
                    </div>

                    <p
                      v-if="showAllEmailMethods"
                      class="text-center font-weight-light my-0 mx-3 mt-2"
                      >or</p
                    >

                    <div v-if="showAllEmailMethods">
                      <button
                        id="sendWithSparkpost"
                        class="btn btn-collapse px-4"
                        :class="!selectedSparkpostEmail && 'collapsed'"
                        data-toggle="collapse"
                        href="#emailAddressSparkpost"
                        role="button"
                        :aria-expanded="selectedSparkpostEmail ? true : false"
                        aria-controls="emailAddressSparkpost"
                        @click="defaultEmail('sparkpost')"
                      >
                        Send with Sparkpost
                      </button>
                      <p class="mb-0 mt-1 text-center">
                        <small class="font-italic font-wwight-light"
                          >15,000 emails/day max
                          <button
                            v-if="showAllEmailMethods"
                            class="btn btn-outline-secondary border-0 d-block mx-auto px-2 mt-2 font-weight-light btn-save-attach"
                            @click.prevent="showOneEmailType"
                          >
                            less
                          </button>
                        </small>
                      </p>
                    </div>

                    <p
                      v-if="showAllEmailMethods"
                      class="text-center font-weight-light my-0 mx-3 mt-2"
                      >or</p
                    >

                    <div v-if="showAllEmailMethods">
                      <button
                        id="sendWithSMTP"
                        class="btn btn-collapse px-4"
                        :class="!selectedSmtpEmail && 'collapsed'"
                        data-toggle="collapse"
                        href="#emailAddressSMTP"
                        role="button"
                        :aria-expanded="selectedSmtpEmail ? true : false"
                        aria-controls="emailAddressSMTP"
                        @click="defaultEmail('smtp')"
                      >
                        Send with SMTP
                      </button>
                      <!-- <div class="mb-0 mt-1 text-center">
                        <small class="font-italic font-wwight-light"
                          >200 emails/day</small
                        >
                      </div> -->
                    </div>
                  </div>

                  <!-- Sparkpost -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4"
                    :class="!selectedSparkpostEmail && 'collapse'"
                    data-parent="#emailOptions"
                  >
                    <div v-if="sparkpostEmails.length <= 0">
                      <small class="text-center font-italic d-block mx-auto">
                        Your SparkPost email account not been linked
                      </small>

                      <div>
                        <button
                          class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                          @click.prevent="saveAndAttachSparkPost"
                        >
                          <BaseIcon name="envelope" class="mr-2" />
                          Save & Attach your Sparkpost Account
                        </button>
                      </div>
                    </div>

                    <div v-else>
                      <h5 class="text-center mt-3 mb-4">
                        Choose your email
                      </h5>

                      <div>
                        <div
                          v-for="(item, index) in sparkpostEmails"
                          :key="index"
                          class="sparkpost-email text-center p-2 mb-3 mx-auto"
                          :class="
                            selectedSparkpostEmail &&
                              selectedSparkpostEmail.email === item.email &&
                              'selected'
                          "
                          @click="selectEmail('sparkpost', item)"
                        >
                          <small
                            class="font-italic font-weight-light"
                            :class="
                              selectedSparkpostEmail &&
                              item.email === selectedSparkpostEmail.email
                                ? 'text-gray'
                                : 'text-gray-light'
                            "
                            >{{ item.email }}</small
                          >
                        </div>
                      </div>

                      <p class="text-center">
                        <small class=" font-weight-light"> or </small>
                      </p>

                      <div>
                        <button
                          class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                          @click.prevent="saveAndAttachSparkPost"
                        >
                          Save & Attach a different Account
                        </button>

                        <!--
                        <button
                          v-if="!campaign.app.internal"
                          class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                          data-toggle="collapse"
                          href="#videoToSearch-0"
                          role="button"
                          aria-expanded="false"
                          aria-controls="videoToSearch"
                          >Continue
                        </button>

                        <button
                          v-if="campaign.app.internal"
                          class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                          data-toggle="collapse"
                          href="#reviewAndEdit-0"
                          role="button"
                          aria-expanded="false"
                          aria-controls="videoToSearch"
                          >Continue
                        </button>
                        -->
                      </div>
                    </div>
                  </div>

                  <!-- GMAIL -->
                  <div
                    v-if="gmailMode"
                    id="emailAddressGmail"
                    class="emails-container py-3 px-4"
                    data-parent="#emailOptions"
                  >
                    <div v-if="googleAccounts.length <= 0">
                      <small class="text-center font-italic d-block mx-auto">
                        Your email account has not been linked <br />
                        <BaseIcon name="envelope" class="mr-2" />
                        Save & Attach
                      </small>

                      <div>
                        <!--
                        <button
                          class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                          @click.prevent="saveAndAttachGoogle"
                        >
                        -->
                        <button
                          class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                          @click.prevent="saveAndAttachGoogle"
                        >
                          <img
                            src="@assets/images/brands/google_dark.png"
                            alt="hello"
                            class="w-50"
                          />
                        </button>
                      </div>
                    </div>

                    <div v-else class="pt-0 pb-3 px-4">
                      <div>
                        <div v-if="!showDifferentAccounts.gmail && gmailMode">
                          <h5 class="text-center mt-3 mb-4">
                            Send with
                          </h5>

                          <div v-if="googleAccounts">
                            <div
                              v-for="(item, index) in googleAccounts"
                              :key="index"
                              class="gmail-email mb-3 mx-auto"
                              :class="
                                googleAccountIsSelected(item) && 'selected'
                              "
                              @click="selectEmail('google', item)"
                            >
                              <div class="d-flex align-items-top p-2">
                                <small class="gmail-pic mr-3 p">
                                  <img
                                    src="@assets/images/icons/user-icon.svg"
                                    alt=""
                                    class="w-100"
                                  />
                                </small>
                                <div class="info d-flex align-items-center">
                                  <!-- <small class="font-weight-bold">{{items[0].name}}</small> -->
                                  <small
                                    class="font-weight-light text-gray d-block info-email"
                                    >{{ item.account_email }}</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--
                      <div v-if="this.selectedGoogleAccounts.length>1">
                        <div v-if="!showDifferentAccounts.gmail">
                          <h5 class="text-center mt-3 mb-4">
                            All emails will reply to this 1 address
                          </h5>

                          <div v-if="googleAccounts">
                            <div
                              v-for="(item, index) in googleAccounts"
                              :key="index"
                              class="gmail-email mb-3 mx-auto"
                              :class="
                                selectedGoogleAccount &&
                                  selectedGoogleAccount.account_email ===
                                    item.account_email &&
                                  'selected'
                              "
                              @click="selectEmail('google', item)"
                            >
                              <div class="d-flex align-items-top p-2">
                                <small class="gmail-pic mr-3 p">
                                  <img
                                    src="@assets/images/icons/user-icon.svg"
                                    alt=""
                                    class="w-100"
                                  />
                                </small>
                                <div class="info d-flex align-items-center">
                                  <small class="font-weight-bold">{{items[0].name}}</small>
                                  <small
                                    class="font-weight-light text-gray d-block info-email"
                                    >{{ item.account_email }}</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      -->

                      <div
                        v-if="selectedGoogleAccounts.length > 1"
                        class="bg-white px-5 pt-4 pb-2"
                      >
                        <div class="row">
                          <div class="col-sm-12 col-md-10 mx-auto">
                            <h5 class="text-center mt-3 mb-4">
                              {{ selectedGoogleAccounts.length }} emails
                              selected
                            </h5>
                            <h5 class="text-center mt-3 mb-4">
                              All emails will reply to this 1 email address
                            </h5>
                            <div class="mb-3">
                              <BaseInputText
                                v-model="campaign.reply_to"
                                name="replyTo"
                                type="text"
                                placeholder="Email for Reply-to"
                                aria-label="replyTo"
                                aria-describedby="basic-addon2"
                                class="form-control"
                              />
                            </div>
                            <!--<p><br/>Email will be used in Reply-To field.</p>-->
                          </div>
                        </div>
                      </div>

                      <p class="text-center">
                        <small class=" font-weight-light"> or </small>
                      </p>

                      <div>
                        <p class="text-center"
                          ><small class=" font-weight-light"
                            >Save & Attach a different Account</small
                          ></p
                        >

                        <button
                          class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                          @click.prevent="saveAndAttachGoogle"
                        >
                          <img
                            src="@assets/images/brands/google_dark.png"
                            alt="hello"
                            class="w-50"
                          />
                        </button>

                        <!--
                        <button
                          v-if="!campaign.app.internal"
                          class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                          data-toggle="collapse"
                          href="#videoToSearch-0"
                          role="button"
                          aria-expanded="false"
                          aria-controls="videoToSearch"
                          >Continue
                        </button>

                        <button
                          v-if="campaign.app.internal"
                          class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                          data-toggle="collapse"
                          href="#reviewAndEdit-0"
                          role="button"
                          aria-expanded="false"
                          aria-controls="videoToSearch"
                          >Continue
                        </button>
                        -->
                      </div>
                    </div>
                  </div>

                  <!-- SMTP -->
                  <div
                    id="emailAddressSMTP"
                    class="emails-container py-3 px-4"
                    :class="!selectedSmtpEmail && 'collapse'"
                    data-parent="#emailOptions"
                  >
                    <div v-if="smtpEmails.length <= 0">
                      <small class="text-center font-italic d-block mx-auto">
                        Your SMTP email account not been linked
                      </small>

                      <div>
                        <button
                          class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                          @click.prevent="saveAndAttachSmtp"
                        >
                          <BaseIcon name="envelope" class="mr-2" />
                          Save & Attach your SMTP Account
                        </button>
                      </div>
                    </div>

                    <div v-else>
                      <h5 class="text-center mt-3 mb-4">
                        Choose your email
                      </h5>

                      <div>
                        <div
                          v-for="(item, index) in smtpEmails"
                          :key="index"
                          class="sparkpost-email text-center p-2 mb-3 mx-auto"
                          :class="
                            selectedSmtpEmail &&
                              selectedSmtpEmail.email === item.email &&
                              'selected'
                          "
                          @click="selectEmail('smtp', item)"
                        >
                          <small
                            class="font-italic font-weight-light"
                            :class="
                              selectedSmtpEmail &&
                              item.email === selectedSmtpEmail.email
                                ? 'text-gray'
                                : 'text-gray-light'
                            "
                            >{{ item.email }}</small
                          >
                        </div>
                      </div>

                      <p class="text-center">
                        <small class=" font-weight-light"> or </small>
                      </p>

                      <div>
                        <button
                          class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                          @click.prevent="saveAndAttachSmtp"
                        >
                          Save & Attach a different Account
                        </button>

                        <!--
                        <button
                          class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                          data-toggle="collapse"
                          href="#videoToSearch-0"
                          role="button"
                          aria-expanded="false"
                          aria-controls="videoToSearch"
                          >Continue
                        </button>
                        -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Next Button --
          <span>
            <div class="text-center px-4">
              <BaseButton
                :click="() => next_step(1, 'campVideo')"
                :disabled="
                  !(
                    (selectedGoogleAccounts.length ||
                      selectedSparkpostEmail ||
                      selectedSmtpEmail) &&
                    (gmailMode || sparkPostMode || smtpMode)
                  )"
                tooltipMessage="You must select an email address"
              >
                Next >
              </BaseButton>
            </div>
          </span> -->
        </div>

        <!-- Step Three Use Video in Emails -->
        <div
          v-if="currentTab === 'campVideo'"
          id="campVideo"
          class="project-settings pt-0"
        >
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                  Activate Video
                </h2>
                <!-- Next Button -->
                <span>
                  <div class="text-center px-4">
                    <BaseButton :click="() => next_step(2, 'campCompose')">
                      Next >
                    </BaseButton>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <!-- Step Three Use Video in Emails -->
          <div id="stepsGroup1" class="card mb-4 overflow-initial steps-group">
            <div class="py-3 px-3 step-box">
              <!-- Screwed up dropdown -->
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="
                        stepTwo ||
                          selectedGoogleAccounts.length ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold">
                    Are we sending videos?
                  </p>

                  <span v-if="videoEmails">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>YES</b></p
                    >
                  </span>
                  <span v-if="!videoEmails">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>NO</b></p
                    >
                  </span>
                </div>
                <button
                  class="btn btn-primary font-weight-normal px-4"
                  data-toggle="collapse"
                  href="#emailAddress"
                  role="button"
                  aria-expanded="false"
                  aria-controls="emailAddress"
                  >Video Emails</button
                >
                <!--
                  :class="
                    stepTwo ||
                    selectedGoogleAccounts.length ||
                    selectedSparkpostEmail ||
                    selectedSmtpEmail
                      ? 'btn-primary'
                      : 'btn-outline-gray'
                  "
                  :disabled="
                    !stepOne &&
                    selectedGoogleAccounts.length === 0 &&
                    !selectedSparkpostEmail
                      ? true
                      : false
                  "
                  -->
              </div>
              <!-- End Screwed Up Dropdown -->

              <div
                id="emailAddress"
                class="collapse show"
                data-parent="#stepsGroup"
              >
                <div
                  id="emailOptions"
                  class="card card-body step-one email-options"
                >
                  <div
                    class="d-flex align-items-top justify-content-center pb-4 mb-2"
                  >
                    <span v-if="videos.length <= 0">
                      <p class="px-3 font-weight-bold">
                        You have no videos.
                        <span class="font-weight-light"
                          >Upload videos to your channel to activate this
                          feature</span
                        >
                      </p>
                      <div>
                        <button
                          class="btn btn-secondary font-weight-normal px-4 d-block mx-auto"
                          @click.prevent="saveAndUploadVideos"
                          >Save Campaign & Upload Videos
                        </button>
                      </div>
                    </span>

                    <span v-else class="align-content-center">
                      <button
                        v-if="videoEmails"
                        class="btn btn-orange font-weight-normal px-4"
                        @click.prevent="changeVideoEmail"
                        >Deactivate Video Emails
                      </button>
                      <button
                        v-else
                        class="btn btn-secondary font-weight-normal px-4"
                        @click.prevent="changeVideoEmail"
                        >Activate Video Emails
                      </button>

                      <!--
                    <div class="mr-2">
                      <div class="onoffswitch onoffswitch-primary">
                        <input
                          id="activate"
                          ref="onoffswitch"
                          v-model="videoEmails"
                          type="checkbox"
                          name="onoffswitch"
                          class="onoffswitch-checkbox"
                          @change="changeVideoEmail()"
                        />
                        <label class="onoffswitch-label m-0" for="activate"></label>
                      </div>
                    </div>
                    -->
                    </span>
                  </div>

                  <!-- Sparkpost -->
                  <!-- TODO how do I get this to show for any choice -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4"
                    data-parent="#emailOptions"
                  >
                    <div>
                      <div
                        id="activateVideoEmailTemplate"
                        data-parent="#stepsGroup"
                      >
                        <div class="card card-body">
                          <div class="bg-light px-5 py-4">
                            <div class="row">
                              <div class="col-sm-12 col-md-10 mx-auto">
                                <div class="card px-3 py-4">
                                  <h3 class="pb-3">
                                    <!--<span class="text-purple">Subject:</span> -->
                                    Introducing Video Emails
                                  </h3>
                                  <p>
                                    Hi There,
                                  </p>
                                  <p>
                                    Sending videos in emails boosts our
                                    click-through-rates 8X.
                                  </p>
                                  <p>
                                    Like when we attended Web Summit
                                  </p>
                                  <button
                                    class="btn btn-outline-secondary border-0 d-block px-0 font-weight-light w-50"
                                    @click.prevent="openVideoNewTab"
                                  >
                                    <img
                                      src="https://app.alphavoice.io/campaign/images/529_preview_key.jpg"
                                      class="w-100"
                                    />
                                  </button>

                                  <p>
                                    Cheers,
                                  </p>
                                  <p>
                                    Ross at Fission Mail
                                  </p>

                                  <!--
                                  <div
                                    class="col-sm-12 col-md-10 col-lg-8 mx-auto"
                                  >
                                    <div
                                      id="activateVideoVideo"
                                      class="embed-responsive embed-responsive-16by9 my-4 position-relative"
                                    >
                                      <div
                                        class="font-weight-light text-gray h6 m-0 video-description pr-5"
                                      >
                                        <iframe
                                          src="https://app.alphavoice.io/video/100989-alphagrowth/29440-why-we-believe-in-video-marketing/embed/"
                                          frameborder="0"
                                          scrolling="no"
                                          allow="autoplay; fullscreen; encrypted-media"
                                          allowfullscreen
                                        ></iframe>
                                      </div>
                                    </div>
                                  </div>
                                  -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Compose Email Steps -->
        <div
          v-if="currentTab === 'campCompose'"
          id="campCompose"
          class="project-settings pt-0"
        >
          <!-- Header -->
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                  Compose
                </h2>
                <!-- Next Button -->
                <span>
                  <div class="text-center">
                    <BaseButton
                      :click="() => (currentTab = 'campOpt')"
                      :disabled="
                        !isCompleteCampaign &&
                          (gmailMode || sparkPostMode || smtpMode)
                      "
                      tooltip-message="One of the emails in your sequence is not ready. Please check for subject and intro/body text."
                    >
                      Next >
                    </BaseButton>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <!-- Compose Email Steps -->
          <span>
            <!-- One Step for Each Email in the Sequence -->
            <div v-for="(form, index) in emailArray" :key="index">
              <!-- Add another email in the sequence -->

              <!-- Choose video and write content per video -->
              <div class="row">
                <div class="col">
                  <!-- <b>Email {{ index + 1 }}. </b> -->
                  <!--<medium class="text-purple"><b>{{form.subject}}</b></medium>-->

                  <!-- I'm commenting this out to prevent confusion: This name is not the subject of the email
                  <div v-if="index !== 0" class="form-group"
                    ><br />
                    <BaseInputText
                      v-model="emailArray[index].name"
                      :placeholder="`Email drip name here`"
                  /></div>
                  -->
                </div>
                <div class="col"> </div>
              </div>

              <span v-if="index > 0">
                <div class="row py-4">
                  <div class="col">
                    <!--<medium><b>Drip</b></medium>-->
                    <div class="form-group">
                      <label for="projectName">
                        <small>Wait X Days</small>
                      </label>
                      <div class="col-sm-2 px-0">
                        <BaseInputText
                          v-model="emailArray[index].start_after"
                          name="emailDripDays"
                          type="number"
                          :placeholder="`2`"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col"> </div>
                </div>
              </span>

              <div
                id="stepsGroup"
                class="card mb-4 overflow-initial steps-group"
              >
                <!-- STEP THREE  -->

                <div
                  v-if="!campaign.app.internal && videoEmails"
                  class="step-box"
                >
                  <div class="py-3 px-3 ">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex align-items-center">
                        <span class="mr-2">
                          <img
                            v-if="emailArray[index].itemSelectedId"
                            src="@assets/images/icons/grey-check.svg"
                            alt=""
                          />
                          <img
                            v-else
                            src="@assets/images/icons/white-check.svg"
                            alt=""
                          />
                        </span>
                        <p class="mt-1 mb-0 font-weight-bold">
                          Which video are you sharing?
                        </p>
                        <p
                          class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                          ><b v-if="emailArray[index].videoSelected">
                            {{
                              truncate_name(
                                emailArray[index].videoSelected.title,
                                60,
                                '...'
                              )
                            }}
                          </b></p
                        >
                      </div>

                      <button
                        class="btn font-weight-normal px-4 btn-collapse"
                        :class="stepThree ? 'btn-primary' : 'btn-outline-gray'"
                        data-toggle="collapse"
                        :href="'#videoToSearch-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="videoToSearch"
                        @click="setActiveEmail(index)"
                        >Select your video</button
                      >
                    </div>
                  </div>
                  <div
                    :id="'videoToSearch-' + index"
                    class="collapse"
                    data-parent="#stepsGroup"
                  >
                    <div class="py-3 px-3 ">
                      <div
                        class="d-flex align-items-center justify-content-between mt-3 mb-0"
                      >
                        <small class="text-left font-weight-light"
                          >Select your video</small
                        >
                      </div>

                      <div class="card card-body position-relative pt-0">
                        <div
                          v-if="secondaryLoading"
                          class="add-episode__loader add-episode__loader--save position-absolute w-100 h-100"
                        >
                          <Transition appear>
                            <div class="spinner-container">
                              <Loader />
                            </div>
                          </Transition>
                        </div>

                        <div
                          v-if="videos.length <= 0"
                          class="container upload mb-4 pt-4 pb-2"
                        >
                          <p
                            >Send Without a Video or Upload a Video to your
                            channel</p
                          >
                          <p
                            ><a
                              >Link to the Channel Page where you can add an
                              episode -- maybe straight to the add an episode
                              page. Save and go there.</a
                            ></p
                          >
                          <p>Also Need An Option to just Send with no Video</p>
                        </div>

                        <div v-else>
                          <div
                            class="videos-container modal-videos__container my-4"
                          >
                            <VideoList
                              v-if="videos"
                              :videos="videos"
                              :zoom="false"
                              :select-video="selectVideo"
                              :upload-videos="true"
                              :select-manually="true"
                              :id-selected="emailArray[index].itemSelectedId"
                              :campaign-selection="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="emailArray[index].itemSelectedId"
                      class="bg-dark p-3 d-flex alignt-items-center justify-content-end"
                    >
                      <button
                        class="btn btn-primary  mx-3"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="
                          selectVideo(null)
                          hideVideoSelectingBlock(index)
                        "
                      >
                        Unselect video & Continue
                      </button>

                      <button
                        class="btn btn-primary"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="hideVideoSelectingBlock(index)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>

                <!-- STEP FOUR -->
                <div class="py-3 px-3 step-box">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <span class="mr-2">
                        <img
                          v-if="
                            emailArray[index].subject &&
                              emailArray[index].intro &&
                              emailArray[index].body
                          "
                          src="@assets/images/icons/grey-check.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="@assets/images/icons/white-check.svg"
                          alt=""
                        />
                      </span>
                      <span v-if="emailArray[index].subject">
                        <p class="mt-1 mb-0 font-weight-bold text-align-right"
                          ><b
                            >Email {{ index + 1 }} :
                            <span class="text-purple">{{
                              truncate_name(
                                emailArray[index].subject,
                                60,
                                '...'
                              )
                            }}</span></b
                          ></p
                        >
                      </span>
                      <span v-else>
                        <p class="mt-1 mb-0 font-weight-bold"
                          >What are you teaching?
                        </p>
                      </span>
                    </div>

                    <div>
                      <button
                        v-if="campaign && emailArray[index].id !== campaign.id"
                        class="btn btn-outline-danger font-weight-light"
                        :disabled="emailArray[index].id === campaign.id"
                        @click="openDeleteEmailModal(index)"
                      >
                        <span class="float-right">
                          <BaseIcon name="trash" />
                        </span>
                      </button>

                      <button
                        class="btn btn-primary font-weight-normal btn-collapse"
                        data-toggle="collapse"
                        :href="'#reviewAndEdit-' + index"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="videoSkipped = true"
                        >Compose your email</button
                      >
                    </div>
                  </div>
                  <div
                    :id="'reviewAndEdit-' + index"
                    class="collapse"
                    data-parent="#stepsGroup"
                  >
                    <div class="card card-body">
                      <div class="bg-light px-5 py-4">
                        <div class="row">
                          <div class="col-sm-12 col-md-10 mx-auto">
                            <div class="card px-3 py-4">
                              <div
                                v-if="
                                  campaign.campaign_list_variables &&
                                    Object.keys(
                                      campaign.campaign_list_variables
                                    ).length > 0
                                "
                                class="d-flex align-items-center subject-variables"
                              >
                                <p class="font-weight-bold mr-2"
                                  >Variables
                                  <small>
                                    - these are mapped from your recipient
                                    data</small
                                  ></p
                                >
                              </div>
                              <div
                                v-if="
                                  campaign.campaign_list_variables &&
                                    Object.keys(
                                      campaign.campaign_list_variables
                                    ).length > 0
                                "
                                class="d-flex align-items-center subject-variables mb-4"
                              >
                                <span
                                  v-for="(v,
                                  clvI) in campaign.campaign_list_variables"
                                  :key="clvI"
                                  class="badge badge-secondary bg-white border border-secondary text-secondary p-1 mr-2"
                                >
                                  <span v-pre>{</span>{{ v
                                  }}<span v-pre>}</span>
                                </span>
                              </div>

                              <div
                                class="d-flex align-items-center subject-variables mb-0"
                              >
                                <p class="font-weight-bold mr-2"
                                  >Subject Line</p
                                >
                              </div>

                              <div class="form-group">
                                <BaseInputText
                                  v-model="emailArray[index].subject"
                                  name="subject"
                                  type="text"
                                  :placeholder="''"
                                  class="mb-1"
                                  :maxlength="max"
                                />
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <!-- <router-link tag="a" to="#">
                                    <small class="text-purple font-weight-light">
                                      How do I write a good subject line?
                                    </small>
                                  </router-link> -->

                                  <small
                                    class="input-group-addon text-gray-input"
                                    v-text="
                                      max -
                                        emailArray[index].subject.length +
                                        ' characters left'
                                    "
                                  ></small>
                                </div>
                                <!-- <button class="btn btn-outline-gray-input px-4 d-block mx-auto my-4">Save</button> -->
                              </div>

                              <span v-if="emailArray[index].videoSelected">
                                <p class="font-weight-bold mr-2 mb-1"
                                  >Intro (optional)</p
                                >
                                <VueEditor
                                  v-model="emailArray[index].intro"
                                  :editor-toolbar="customEditorToolbar"
                                ></VueEditor>
                              </span>

                              <div
                                v-if="emailArray[index].videoSelected"
                                id="mainVideo"
                                class="embed-responsive embed-responsive-16by9 my-4 position-relative"
                              >
                                <div
                                  class="font-weight-light text-gray h6 m-0 video-description pr-5"
                                >
                                  <iframe
                                    :src="
                                      emailArray[index].videoSelected.player_url
                                    "
                                    frameborder="0"
                                    scrolling="no"
                                    allow="autoplay; fullscreen; encrypted-media"
                                    allowfullscreen
                                  ></iframe>
                                </div>
                                <button
                                  class="btn bg-transparent border-0 px-0 position-absolute btn-edit"
                                  @click.prevent="openEpisodeLink"
                                >
                                  <span class="text-primary"
                                    ><BaseIcon name="edit"
                                  /></span>
                                </button>
                              </div>

                              <!--
                              <div v-else>
                                <div class="clearfix"><br /></div>
                                <div class="clearfix"><br /></div>
                                <div class="clearfix"><br /></div>
                              </div>
                              -->

                              <p class="font-weight-bold mr-2 mb-1">
                                Body
                              </p>
                              <VueEditor
                                v-model="emailArray[index].body"
                                :editor-toolbar="customEditorToolbar"
                              ></VueEditor>
                            </div>

                            <!-- <button
                              class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                              :disabled="
                                (!emailArray[index].intro && !emailArray[index].body) || validateCampaignLock
                              "
                              @click.prevent="validateCampaign"
                            >
                              Save & Check Spam Score
                            </button> -->

                            <div
                              v-if="
                                validationMatchedWords &&
                                  validationMatchedWords.length > 0
                              "
                            >
                              Try to replace or remove the following words and
                              check again<br />
                              <span
                                v-for="(word, idx) in validationMatchedWords"
                                :key="idx"
                                class="badge badge-purple font-weight-normal mr-1 mb-1 py-1"
                                >{{ word }}</span
                              >
                              <p class="help-block"
                                ><small
                                  >Spam filters may reject mail sent with these
                                  words.</small
                                ></p
                              >
                            </div>

                            <div
                              v-if="
                                validationMatchedWords &&
                                  validationMatchedWords.length === 0
                              "
                            >
                              Cool! No spammy words found!<br />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="bg-white px-5 pt-4 pb-2">
                        <div class="row">
                          <div class="col-sm-12 col-md-6 mx-auto">
                            <div v-if="mailTemplates">
                              <h3>Choose an email template</h3>
                              <Multiselect
                                v-model="emailArray[index].mailTemplate"
                                select-label="Select"
                                :allow-empty="false"
                                class="multiselect-episode-actions mx-auto"
                                :options="mailTemplates"
                                track-by="id"
                                label="title"
                                :multiple="false"
                                :close-on-select="true"
                                placeholder="Mail template"
                              />
                              <br />
                              <h3>Send a test email</h3>
                            </div>

                            <div
                              v-if="selectedGoogleAccounts.length > 0"
                              class="input-group "
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-secondary py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email</button
                                >
                              </div>
                            </div>
                            <p
                              v-if="selectedGoogleAccounts.length > 0"
                              class="font-weight-bold"
                              ><br />Gmail sending accounts -
                              {{ sendTestEmailsString }}</p
                            >

                            <!--<h3 v-if="selectedSparkpostEmail">Send test email to: </h3>-->
                            <div
                              v-if="selectedSparkpostEmail"
                              class="input-group mb-3"
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-gray py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email from
                                  {{ selectedSparkpostEmail.email }}</button
                                >
                              </div>
                            </div>

                            <h3 v-if="selectedSmtpEmail"
                              >Send test email to:
                            </h3>
                            <div
                              v-if="selectedSmtpEmail"
                              class="input-group mb-3"
                            >
                              <BaseInputText
                                v-model="emailArray[index].testEmail"
                                name="testEmail"
                                type="text"
                                :placeholder="'your+email@example.com'"
                                aria-label="testEmail"
                                aria-describedby="basic-addon2"
                                class="form-control test-email"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-gray py-1"
                                  :disabled="
                                    emailArray[index].testEmail.length === 0 ||
                                      emailSending
                                  "
                                  @click.prevent="sendTestEmail(index)"
                                  >Send test email from
                                  {{ selectedSmtpEmail.email }}</button
                                >
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="
                              selectedGoogleAccounts.length > 0 ||
                                selectedSparkpostEmail ||
                                selectedSmtpEmail
                            "
                          >
                            <div class="col-sm-12 col-md-12 mx-auto">
                              <button
                                v-if="campaign"
                                class="btn btn-primary font-weight-light px-5"
                                @click="previewCampaignEmail(index)"
                              >
                                Preview email
                                <span class="pl-3 float-right">
                                  <BaseIcon name="external-link-alt" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--
                      <div class="bg-white px-5 pt-4 pb-2">
                        <div class="row">
                          <div class="col-sm-12 col-md-8 mx-auto"> </div>

                          <div>
                            <div class="col-sm-12 col-md-12 mx-auto">
                              <button
                                v-if="campaign"
                                class="btn btn-purple font-weight-light px-5"
                                :disabled="emailArray[index].id === campaign.id"
                                @click="openDeleteEmailModal(index)"
                              >
                                DELETE email
                                <span class="pl-3 float-right">
                                  <BaseIcon name="trash" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      -->
                    </div>

                    <!--
                    <div
                      v-if="
                        selectedGoogleAccounts.length > 0 ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      class="bg-white pt-2 pb-4 text-center"
                    >
                      <div class="row">
                        <div class="col-sm-12 col-md-10 mx-auto">
                          <button
                            v-if="campaign"
                            class="btn btn-primary font-weight-light px-5"
                            @click="previewCampaign"
                          >
                            Preview email
                            <span class="pl-3 float-right">
                              <BaseIcon name="external-link-alt" />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                    -->

                    <div
                      v-if="emailArray[index].subject && emailArray[index].body"
                      class="bg-dark p-3 d-flex alignt-items-center justify-content-end"
                    >
                      <button
                        class="btn btn-primary"
                        data-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="reviewAndEdit"
                        @click="hideEditBlock(index)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add another email button -->
              <span v-if="index === emailArray.length - 1">
                <div class="text-center">
                  <button
                    class="btn btn-outline-gray font-weight-light my-3 px-4 mx-2"
                    @click.prevent="addDrip"
                  >
                    + Add Drip
                  </button>
                </div>
              </span>
            </div>
          </span>
        </div>

        <!-- Step Six Options Page -->
        <div
          v-if="currentTab === 'campOpt'"
          id="campOpt"
          class="project-settings pt-0"
        >
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                  Campaign Options
                </h2>
                <!-- Next Button -->
                <span>
                  <div class="text-center">
                    <BaseButton
                      :click="() => next_step(6, 'campSend')"
                      :disabled="!options[3]"
                      tooltip-message="Please agree to follow email laws"
                    >
                      Next >
                    </BaseButton>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <!-- Step Six Options Page -->
          <div id="stepsGroup1" class="card mb-4 overflow-initial steps-group">
            <div class="py-3 px-3 step-box">
              <!-- Screwed up dropdown -->
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="
                        stepTwo ||
                          selectedGoogleAccounts.length ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold">
                    Finalize your campaign
                  </p>
                </div>
                <button
                  class="btn btn-primary font-weight-normal px-4"
                  data-toggle="collapse"
                  href="#emailAddress"
                  role="button"
                  aria-expanded="false"
                  aria-controls="emailAddress"
                  >Campaign Options</button
                >
                <!--
                  :class="
                    stepTwo ||
                    selectedGoogleAccounts.length ||
                    selectedSparkpostEmail ||
                    selectedSmtpEmail
                      ? 'btn-primary'
                      : 'btn-outline-gray'
                  "
                  :disabled="
                    !stepOne &&
                    selectedGoogleAccounts.length === 0 &&
                    !selectedSparkpostEmail
                      ? true
                      : false
                  "
                  -->
              </div>
              <!-- End Screwed Up Dropdown -->

              <div
                id="emailAddress"
                class="collapse show"
                data-parent="#stepsGroup"
              >
                <div
                  id="emailOptions"
                  class="card card-body step-one email-options"
                >
                  <div
                    class="d-flex align-items-top justify-content-center pb-4 mb-2"
                  >
                  </div>
                  <!-- Recipients -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4 pb-3"
                    data-parent="#emailOptions"
                  >
                    <div>
                      <!--
                      <div class="d-flex align-items-center">
                        <div
                          class="form-check pr-2 pl-4 pt-0 mt-0 ml-2"
                          style="height: 16px;"
                        >
                          <input
                            id="no_spam"
                            v-model="options[0]"
                            type="checkbox"
                            :value="options[0]"
                            class="form-check-input mt-0"
                          />
                        </div>
                          <h2 class="text-left mt-3 mb-4">
                            Track Opens
                          </h2>
                      </div>

                      <div class="d-flex align-items-center">
                        <div
                          class="form-check pr-2 pl-4 pt-0 mt-0 ml-2"
                          style="height: 16px;"
                        >
                          <input
                            id="no_spam"
                            v-model="options[1]"
                            type="checkbox"
                            :value="options[1]"
                            class="form-check-input mt-0"
                          />
                        </div>
                        <h2 class="text-left mt-3 mb-4">
                          Track Link Clicks
                        </h2>
                      </div>

                      <div class="d-flex align-items-center">
                          <div
                            class="form-check pr-2 pl-4 pt-0 mt-0 ml-2"
                            style="height: 16px;"
                          >
                            <input
                              id="no_spam"
                              v-model="options[2]"
                              type="checkbox"
                              :value="options[2]"
                              class="form-check-input mt-0"
                            />
                          </div>
                            <h2 class="text-left mt-3 mb-4">
                              Schedule this send
                            </h2>
                      </div>
                      -->

                      <div class="d-flex align-items-center">
                        <div
                          class="form-check pr-2 pl-4 pt-0 mt-0 ml-2"
                          style="height: 16px;"
                        >
                          <input
                            id="no_spam"
                            v-model="options[3]"
                            type="checkbox"
                            :value="options[3]"
                            class="form-check-input mt-0"
                          />
                        </div>
                        <h2 class="text-left mt-3 mb-4">
                          I will obey pertinent email sending laws
                          <!--I will obey pertinent laws and I've read these important notes-->
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Next Button -
          <span>
            <div class="text-center">
              <BaseButton
                :click="() => next_step(6, 'campSend')"
                :disabled="!options[3]"
                tooltipMessage="Please agree to follow email laws"
              >
                Next >
              </BaseButton>
            </div>
          </span>
          -->
        </div>

        <!-- LAST STEP GROUP -- START CAMPAIGN -->
        <div
          v-if="currentTab === 'campSend'"
          id="campSend"
          class="project-settings pt-0"
        >
          <div class="row">
            <div class="col">
              <h2 class="py-4 font-weight-bold text-left d-block mx-auto">
                Review & Send
              </h2>
            </div>
            <div class="col"> </div>
          </div>
          <!-- LAST STEP GROUP -- START CAMPAIGN -->
          <!-- Step Three Use Video in Emails -->
          <div id="stepsGroup1" class="card mb-4 overflow-initial steps-group">
            <div class="py-3 px-3 step-box">
              <!-- Screwed up dropdown -->
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="
                        stepTwo ||
                          selectedGoogleAccounts.length ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail
                      "
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold">
                    Is everything correct?
                  </p>

                  <!--
                  <span v-if="videoEmails">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>YES</b></p
                    >
                  </span>
                  <span v-if="!videoEmails">
                    <p
                      class="ml-5 mt-1 mb-0 font-weight-bold text-purple text-align-right"
                      ><b>NO</b></p
                    >
                  </span>
                  -->
                </div>
                <button
                  class="btn btn-primary font-weight-normal px-4"
                  data-toggle="collapse"
                  href="#emailAddress"
                  role="button"
                  aria-expanded="false"
                  aria-controls="emailAddress"
                  >Review Campaign</button
                >
                <!--
                  :class="
                    stepTwo ||
                    selectedGoogleAccounts.length ||
                    selectedSparkpostEmail ||
                    selectedSmtpEmail
                      ? 'btn-primary'
                      : 'btn-outline-gray'
                  "
                  :disabled="
                    !stepOne &&
                    selectedGoogleAccounts.length === 0 &&
                    !selectedSparkpostEmail
                      ? true
                      : false
                  "
                  -->
              </div>
              <!-- End Screwed Up Dropdown -->

              <div
                id="emailAddress"
                class="collapse show"
                data-parent="#stepsGroup"
              >
                <div
                  id="emailOptions"
                  class="card card-body step-one email-options"
                >
                  <!-- Sparkpost -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4 pb-3"
                    data-parent="#emailOptions"
                  >
                    <div>
                      <h2 class="text-left mt-3 mb-4">
                        From Address
                      </h2>

                      <span v-if="selectedSmtpEmail">
                        <small class="text-left text-purple">
                          Sending Account
                        </small>
                        <p class="text-left">
                          {{ selectedSmtpEmail.email }}
                        </p>
                      </span>

                      <span v-if="selectedSparkpostEmail">
                        <small class="text-left text-purple">
                          Sending Account
                        </small>
                        <p class="text-left">
                          {{ selectedSparkpostEmail.email }}
                        </p>
                      </span>

                      <span v-if="selectedGoogleAccounts.length === 1">
                        <small class="text-left text-purple">
                          Sending Account
                        </small>
                        <p class="text-left">
                          {{ sendTestEmailsString }}
                        </p>
                      </span>

                      <span v-if="selectedGoogleAccounts.length > 1">
                        <small class="text-left text-purple">
                          Sending Accounts
                        </small>
                        <p class="text-left">
                          {{ sendTestEmailsString }}
                        </p>
                      </span>

                      <span v-if="campaign.reply_to">
                        <small class="text-left text-purple">
                          Reply to Account
                        </small>
                        <p class="text-left">
                          {{ campaign.reply_to }}
                        </p>
                      </span>
                    </div>
                  </div>

                  <!-- Recipients -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4 pb-3"
                    data-parent="#emailOptions"
                  >
                    <div>
                      <h2 class="text-left mt-3 mb-4">
                        Recipients
                      </h2>

                      <small class="text-left text-purple">
                        total emails
                      </small>
                      <p class="text-left">
                        {{ campaign.total_leads_count }} recipients will be sent
                        this campaign immediately.
                      </p>
                      <!--
                      <ul>

                        <p  class="text-left">
                          {{ sendTestEmailsString }}
                          {{ combineExampleEmails }}
                        </p>

                        <p  class="text-left">
                          ... and {{ campaign.total_leads_count - 4 }} more.
                        </p>
                      </ul>
                      -->
                    </div>
                  </div>

                  <!-- Messages -->
                  <div
                    id="emailAddressSparkpost"
                    class="emails-container py-3 px-4 pb-3"
                    data-parent="#emailOptions"
                  >
                    <div>
                      <h2 class="text-left mt-3 mb-4">
                        Messages
                      </h2>

                      <span v-for="(item, index) in emailArray" :key="index">
                        <small class="text-left te+ t-purple">
                          email {{ index + 1 }}
                        </small>
                        <p class="text-left">
                          {{ item.subject }}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="stepsGroup" class="card mb-4 overflow-initial steps-group">
            <!-- STEP FIVE -->
            <div class="py-3 px-3 step-box">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mr-2">
                    <img
                      v-if="stepThree"
                      src="@assets/images/icons/grey-check.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@assets/images/icons/white-check.svg"
                      alt=""
                    />
                  </span>
                  <p class="mt-1 mb-0 font-weight-bold">Ready to send?</p>
                </div>

                <button
                  class="btn btn-outline-gray font-weight-normal btn-collapse"
                  data-toggle="collapse"
                  href="#reviewAndSend"
                  role="button"
                  aria-expanded="false"
                  aria-controls="reviewAndEdit"
                  >Send your email</button
                >
              </div>
              <div id="reviewAndSend" data-parent="#stepsGroup">
                <div
                  v-if="campaignLists && campaignLists.length !== 0"
                  class="bg-light px-5 py-4"
                >
                  <div class="row">
                    <div class="col-sm-12 col-md-10 mx-auto">
                      <div
                        v-if="campaign.total_leads_count > 0"
                        class="text-center mb-4"
                      >
                        <h3 class="mb-0"
                          >You are about to send
                          <span>{{ emailArray.length }}</span>
                          email<span v-if="campaign.total_leads_count > 0"
                            >s</span
                          >
                          to {{ campaign.total_leads_count }} leads, are you
                          ready?</h3
                        >
                        <h3 class="mb-0 text-purple"
                          >This costs ${{ currentCost }}</h3
                        >

                        <span v-for="(item, index) in emailArray" :key="index">
                          <small class="text-left te+ t-purple">
                            email {{ index + 1 }} __
                            <span class="text-black"
                              >${{ currentCost / emailArray.length }}</span
                            ><br />
                          </small>
                        </span>

                        <p
                          v-if="
                            currentCost !== currentCostDifference &&
                              currentCostDifference > 0 &&
                              !campaign.app.internal
                          "
                          class="text-center"
                          ><small
                            >Save ${{ currentCostDifference }} when you include
                            a video</small
                          ></p
                        >

                        <!--<small class="font-weight-light disclaimer"
                            >This will cost {{ currentCost }} USD in the
                            future. For now it's free! You're welcome
                          </small>-->
                      </div>

                      <div class="text-center text-danger">
                        <p
                          v-if="
                            !(
                              selectedGoogleAccounts.length > 0 ||
                              selectedSparkpostEmail ||
                              selectedSmtpEmail
                            )
                          "
                          >You have not selected an email to send from</p
                        >
                        <p v-if="!isCompleteCampaign" class="text-danger"
                          >One of the emails in your sequence is not ready.<br />Please
                          check for subject and intro/body text.</p
                        >
                      </div>

                      <div v-if="campaign" class="text-center">
                        <button
                          v-if="campaign.status === 0"
                          class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                          :disabled="
                            campaign.total_leads_count === 0 ||
                              lockStartCampaignButton ||
                              !isCompleteCampaign ||
                              !(
                                selectedGoogleAccounts.length > 0 ||
                                selectedSparkpostEmail ||
                                selectedSmtpEmail
                              )
                          "
                          @click.prevent="openStartCampaignModal"
                        >
                          Start campaign
                        </button>
                        <button
                          v-if="
                            (selectedGoogleAccounts.length > 0 ||
                              selectedSparkpostEmail ||
                              selectedSmtpEmail) &&
                              campaign.status === 3
                          "
                          class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                          :disabled="
                            campaign.total_leads_count === 0 ||
                              lockStartCampaignButton ||
                              !isCompleteCampaign
                          "
                          @click.prevent="openStartCampaignModal"
                        >
                          Resume campaign
                        </button>

                        <button
                          v-if="
                            (selectedGoogleAccounts.length > 0 ||
                              selectedSparkpostEmail ||
                              selectedSmtpEmail) &&
                              campaign.status === 2 &&
                              !campaign.is_sent
                          "
                          class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                          :disabled="
                            lockStartCampaignButton || !isCompleteCampaign
                          "
                          @click.prevent="openStartCampaignModal"
                        >
                          Resume campaign
                        </button>

                        <button
                          class="btn btn-outline-gray font-weight-light my-3 px-4 mx-2"
                          @click.prevent="saveAndClose"
                        >
                          Save & Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>

    <SweetModal ref="deleteModal" overlay-theme="dark" width="50%">
      <div class="p-5">
        <h2 class="font-weight-bold px-4">Delete Email drip</h2>
        <h5 class="font-weight-bold px-4 mb-4">Delete email</h5>

        <form action="" class="px-4">
          <div class="d-flex align-items-center justify-content-end mt-5 mb-3">
            <button
              class="btn btn-outline text-gray-input mr-2"
              @click.prevent="closeDeleteModal"
              >Cancel & Return</button
            >

            <button class="btn btn-danger px-5" @click.prevent="deleteEmail">
              Delete
            </button>
          </div>
        </form>
      </div>
    </SweetModal>

    <SweetModal ref="startCampaignModal" overlay-theme="dark" width="50%">
      <div v-if="campaign" class="p-5">
        <h2 v-if="campaign.status === 0" class="font-weight-bold px-4"
          >Start campaign</h2
        >
        <h2 v-if="campaign.status === 3" class="font-weight-bold px-4"
          >Resume campaign</h2
        >
        <h5 class="font-weight-bold px-4 mb-4"
          >Please sure that you previewed all emails</h5
        >

        <form action="" class="px-4">
          <div class="d-flex align-items-center justify-content-end mt-5 mb-3">
            <button
              class="btn btn-outline text-gray-input mr-2"
              @click.prevent="closeStartCampaignModal"
              >Cancel & Return</button
            >

            <button
              v-if="campaign.status === 0"
              class="btn btn-primary px-5"
              :disabled="lockStartCampaignButton"
              @click.prevent="startCampaign"
            >
              Start campaign
            </button>
            <button
              v-if="campaign.status === 3"
              class="btn btn-primary px-5"
              :disabled="lockStartCampaignButton"
              @click.prevent="startCampaign"
            >
              Resume campaign
            </button>

            <button
              v-if="campaign.status === 2 && !campaign.is_sent"
              class="btn btn-primary px-5"
              :disabled="lockStartCampaignButton"
              @click.prevent="startCampaign"
            >
              Resume campaign
            </button>
          </div>
        </form>
      </div>
    </SweetModal>
  </div>
</template>
